// import React, { useState, useEffect, useRef } from "react";
// import {
//   Box,
//   Typography,
//   Card,
//   Button,
//   Alert,
//   CircularProgress,
//   Modal,
//   IconButton,
//   Stack,
//   TextField,
//   useMediaQuery,
//   useTheme,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemSecondaryAction,
//   Paper,
//   Divider
// } from "@mui/material";
// import { Icon } from "../../icons";
// import { COLORS, TYPOGRAPHY } from "../../constants/color";
// import { useAuth } from "../../context/authContext";
// import axios from "axios";
// import { url } from "../../constants/url";

// // Simple MDEditor import
// import MDEditor from '@uiw/react-md-editor';
// import ReactMarkdown from "react-markdown";
// import remarkGfm from "remark-gfm";

// import SignatureCanvas from "../../components/siteCheck/SignatureCanvas";
// import AppToast from "../../components/AppToast";

// const truncate = (text, length = 250) =>
//   text?.length > length ? text.substring(0, length) + "..." : text;

// // Helper function to get full image URL
// const getFullImageUrl = (imagePath) => {
//   if (!imagePath) return null;

//   if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
//     return imagePath;
//   }

//   if (imagePath.startsWith('data:image')) {
//     return imagePath;
//   }

//   // Clean the path - replace backslashes with forward slashes
//   let cleanPath = imagePath.replace(/\\/g, '/');
//   cleanPath = cleanPath.startsWith('/') ? cleanPath.substring(1) : cleanPath;

//   return `${url}/${cleanPath}`;
// };

// const GeneralSettings = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   const { token, userData } = useAuth();

//   console.log("UserData from auth:", userData);
//   console.log("User role:", userData?.role);

//   const isAdmin = userData?.role === "ADMIN" || userData?.role === "SUPERADMIN";
//   // Update: Engineers can also have signatures
//   const canHaveSignature = userData?.role === "ADMIN" || userData?.role === "ENGINEER" || userData?.role === "SUPERADMIN";

//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(null);

//   const [thankYou, setThankYou] = useState({ _id: "", title: "", content: "" });
//   const [terms, setTerms] = useState({ _id: "", title: "", content: "" });
//   const [adminInfo, setAdminInfo] = useState(null);
//   const [signature, setSignature] = useState(null);

//   const [modalOpen, setModalOpen] = useState(false);
//   const [modalMode, setModalMode] = useState("view");
//   const [activeType, setActiveType] = useState("THANK_YOU");
//   const [tempData, setTempData] = useState({ title: "", content: "" });

//   const [signatureModalOpen, setSignatureModalOpen] = useState(false);
//   const [adminModalOpen, setAdminModalOpen] = useState(false);
//   const [tempAdminInfo, setTempAdminInfo] = useState({ name: "", email: "", phone: "" });

//   // New state for checklist order management
//   const [checklistOrderModalOpen, setChecklistOrderModalOpen] = useState(false);
//   const [checklistTemplates, setChecklistTemplates] = useState([]);
//   const [draggedItem, setDraggedItem] = useState(null);
//   const [dropTarget, setDropTarget] = useState(null);
//   const [isUpdatingOrder, setIsUpdatingOrder] = useState(false);

//   const signatureCanvasRef = useRef(null);
//   const [editorFullscreen, setEditorFullscreen] = useState(false);
//   const [editorPreviewMode, setEditorPreviewMode] = useState("live"); // live, edit, preview

//   // Toast state
//   const [toast, setToast] = useState({
//     open: false,
//     type: "success",
//     title: "",
//     message: ""
//   });

//   // Show toast function
//   const showToast = (type, title, message) => {
//     setToast({
//       open: true,
//       type,
//       title,
//       message
//     });
//     setTimeout(() => {
//       setToast(prev => ({ ...prev, open: false }));
//     }, 5000);
//   };

//   useEffect(() => {
//     if (isAdmin) {
//       fetchData();
//     } else {
//       // For engineers, just set loading to false
//       setLoading(false);
//     }
//   }, [isAdmin, token, userData?.role]);

//   useEffect(() => {
//     console.log("📋 Signature useEffect triggered");
//     console.log("User role:", userData?.role);
//     console.log("Can have signature:", canHaveSignature);
//     console.log("User ID:", userData?._id);

//     if (canHaveSignature && userData?._id) {
//       console.log("✅ Fetching signature for user:", userData._id);
//       fetchSignature();
//     } else {
//       console.log("❌ Cannot fetch signature:");
//       if (!canHaveSignature) console.log("  - User role not allowed:", userData?.role);
//       if (!userData?._id) console.log("  - No user ID");
//     }
//   }, [canHaveSignature, userData, token]);

//   const fetchData = async () => {
//     try {
//       setLoading(true);

//       // Only admins can fetch these settings
//       if (isAdmin) {
//         // Fetch Thank You content
//         const tyResponse = await axios.get(`${url}/api/general/content/THANK_YOU`, { 
//           headers: { Authorization: `Bearer ${token}` } 
//         });

//         console.log("Thank You API Response:", tyResponse.data);

//         // Fetch Terms & Conditions content  
//         const tcResponse = await axios.get(`${url}/api/general/content/TERMS_CONDITIONS`, { 
//           headers: { Authorization: `Bearer ${token}` } 
//         });

//         console.log("Terms API Response:", tcResponse.data);

//         // Fetch admin user data
//         const adminResponse = await axios.get(`${url}/api/users/fetch?role=ADMIN&limit=1`, { 
//           headers: { Authorization: `Bearer ${token}` } 
//         });

//         console.log("Admin API Response:", adminResponse.data);

//         // Handle Thank You data
//         if (tyResponse.data?.data) {
//           const tyData = tyResponse.data.data;
//           const data = Array.isArray(tyData) ? tyData[0] : tyData;
//           setThankYou({
//             _id: data?._id || "",
//             title: data?.title || "Thank You Message",
//             content: data?.content || ""
//           });
//         }

//         // Handle Terms & Conditions data
//         if (tcResponse.data?.data) {
//           const tcData = tcResponse.data.data;
//           const data = Array.isArray(tcData) ? tcData[0] : tcData;
//           setTerms({
//             _id: data?._id || "",
//             title: data?.title || "Terms & Conditions",
//             content: data?.content || ""
//           });
//         }

//         // Handle Admin data
//         if (adminResponse.data?.users?.[0]) {
//           const adminData = adminResponse.data.users[0];
//           setAdminInfo({
//             _id: adminData._id,
//             name: adminData.name || "",
//             email: adminData.email || "",
//             phone: adminData.phone || ""
//           });
//         }
//       }

//       setError(null);
//     } catch (err) {
//       console.error("Fetch error:", err);
//       setError("Failed to fetch data. Please check console for details.");
//       showToast("error", "Error", "Failed to fetch data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchSignature = async () => {
//     try {
//       if (!userData?._id) {
//         console.log("No user ID available");
//         return;
//       }

//       console.log("Fetching signature for user ID:", userData._id);
//       console.log("User role for signature:", userData?.role);

//       const res = await axios.get(`${url}/api/users/signature/${userData._id}`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });

//       console.log("Signature API Response:", res.data);

//       if (res.data?.data?.hasSignature) {
//         const signatureData = res.data.data;
//         const fullSignaturePath = getFullImageUrl(signatureData.signature);

//         console.log("Full signature URL:", fullSignaturePath);
//         console.log("Signature data:", signatureData);

//         setSignature({
//           ...signatureData,
//           signature: fullSignaturePath
//         });
//       } else if (res.data?.message === "No signature found for this user") {
//         console.log("No signature found for user");
//         setSignature(null);
//       } else if (res.data?.data) {
//         const signatureData = res.data.data;
//         if (signatureData.signature) {
//           const fullSignaturePath = getFullImageUrl(signatureData.signature);
//           setSignature({
//             ...signatureData,
//             signature: fullSignaturePath,
//             hasSignature: true
//           });
//         } else {
//           console.log("No signature in data");
//           setSignature(null);
//         }
//       } else {
//         console.log("Unexpected response format");
//         setSignature(null);
//       }
//     } catch (err) {
//       console.error("Signature fetch error:", err);
//       console.error("Error status:", err.response?.status);
//       console.error("Error data:", err.response?.data);
//       if (err.response?.status !== 404) {
//         console.error("Error fetching signature:", err);
//       }
//       setSignature(null);
//     }
//   };

//   // New function to fetch checklist templates
//   const fetchChecklistTemplates = async () => {
//     try {
//       console.log("Fetching checklist templates...");

//       const res = await axios.get(`${url}/api/admin/checklist-templates`, {
//         headers: { Authorization: `Bearer ${token}` },
//         params: {
//           sort: 'oldest', // Get in ascending order by creation date
//           limit: 100 // Get all templates
//         }
//       });

//       console.log("Checklist templates response:", res.data);

//       if (res.data?.data) {
//         // Sort by createdAt ascending (oldest first)
//         const sortedTemplates = [...res.data.data].sort((a, b) => {
//           return new Date(a.createdAt) - new Date(b.createdAt);
//         });

//         setChecklistTemplates(sortedTemplates);
//         showToast("success", "Success", "Checklist templates loaded successfully");
//       }
//     } catch (err) {
//       console.error("Error fetching checklist templates:", err);
//       showToast("error", "Error", "Failed to load checklist templates");
//     }
//   };

//   // New function to open checklist order modal
//   const openChecklistOrderModal = async () => {
//     try {
//       setChecklistOrderModalOpen(true);
//       await fetchChecklistTemplates();
//     } catch (err) {
//       console.error("Error opening checklist order modal:", err);
//     }
//   };

//   // Drag and drop handlers
//   const handleDragStart = (e, index) => {
//     e.dataTransfer.effectAllowed = "move";
//     e.currentTarget.style.opacity = "0.5";
//     setDraggedItem(index);
//   };

//   const handleDragOver = (e, index) => {
//     e.preventDefault();
//     e.stopPropagation();
//     e.dataTransfer.dropEffect = "move";
//     setDropTarget(index);
//   };

//   const handleDragEnd = (e) => {
//     e.currentTarget.style.opacity = "1";
//     setDraggedItem(null);
//     setDropTarget(null);
//   };

//   const handleDrop = (e, targetIndex) => {
//     e.preventDefault();
//     e.stopPropagation();

//     if (draggedItem === null || draggedItem === targetIndex) {
//       setDraggedItem(null);
//       setDropTarget(null);
//       return;
//     }

//     // Reorder the checklist templates
//     const updatedTemplates = [...checklistTemplates];
//     const [draggedTemplate] = updatedTemplates.splice(draggedItem, 1);
//     updatedTemplates.splice(targetIndex, 0, draggedTemplate);

//     // Update serial numbers based on new order
//     const renumberedTemplates = updatedTemplates.map((template, index) => ({
//       ...template,
//       displayOrder: index + 1
//     }));

//     setChecklistTemplates(renumberedTemplates);
//     setDraggedItem(null);
//     setDropTarget(null);

//     showToast("info", "Order Changed", "Drag to reorder, click Save to apply changes");
//   };

//   // Save the new order
//   const saveChecklistOrder = async () => {
//     try {
//       setIsUpdatingOrder(true);

//       // Prepare the order data
//       const orderData = checklistTemplates.map((template, index) => ({
//         _id: template._id,
//         title: template.title,
//         displayOrder: index + 1
//       }));

//       console.log("Saving checklist order:", orderData);

//       // You'll need to create an API endpoint for this
//       const res = await axios.put(`${url}/api/general/checklist-order`, 
//         { templates: orderData },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       console.log("Save order response:", res.data);

//       if (res.data?.success) {
//         showToast("success", "Success", "Checklist order saved successfully");
//         setChecklistOrderModalOpen(false);
//       } else {
//         throw new Error(res.data?.message || "Failed to save order");
//       }
//     } catch (err) {
//       console.error("Error saving checklist order:", err);
//       showToast("error", "Error", err.response?.data?.message || "Failed to save checklist order");
//     } finally {
//       setIsUpdatingOrder(false);
//     }
//   };

//   const openModal = (type, mode) => {
//     const data = type === "THANK_YOU" ? thankYou : terms;
//     setActiveType(type);
//     setModalMode(mode);
//     setTempData({ 
//       _id: data._id,
//       title: data.title || "",
//       content: data.content || "" 
//     });
//     setModalOpen(true);
//     // Reset editor states
//     setEditorFullscreen(false);
//     setEditorPreviewMode("live");
//   };

//   const openAdminModal = () => {
//     if (adminInfo) {
//       setTempAdminInfo({
//         name: adminInfo.name || "",
//         email: adminInfo.email || "",
//         phone: adminInfo.phone || ""
//       });
//     }
//     setAdminModalOpen(true);
//   };

//   const save = async () => {
//     try {
//       setSaving(true);

//       const payload = {
//         contentType: activeType,
//         title: tempData.title,
//         content: tempData.content,
//         isActive: true
//       };

//       console.log("Saving payload:", payload);

//       let res;
//       if (tempData._id) {
//         res = await axios.put(`${url}/api/general/content/${tempData._id}`, payload, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//       } else {
//         res = await axios.post(`${url}/api/general/content`, payload, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//       }

//       console.log("Save response:", res.data);

//       if (res.data?.data) {
//         const savedData = res.data.data;
//         if (activeType === "THANK_YOU") {
//           setThankYou(savedData);
//         } else {
//           setTerms(savedData);
//         }

//         setModalOpen(false);
//         showToast("success", "Success", "Content saved successfully");
//         setError(null);
//       }

//     } catch (err) {
//       console.error("Save error:", err);
//       showToast("error", "Error", "Failed to save content");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const saveAdminInfo = async () => {
//     try {
//       setSaving(true);

//       const res = await axios.put(`${url}/api/users/update/${adminInfo._id}`, tempAdminInfo, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       console.log("Admin update response:", res.data);

//       if (res.data?.user) {
//         setAdminInfo(prev => ({
//           ...prev,
//           ...res.data.user
//         }));
//         setAdminModalOpen(false);
//         showToast("success", "Success", "Admin information updated successfully");
//       }

//     } catch (err) {
//       console.error("Admin update error:", err);
//       showToast("error", "Error", "Failed to update admin information");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const saveSignature = async () => {
//     try {
//       setSaving(true);

//       if (!signatureCanvasRef.current) {
//         showToast("error", "Error", "Signature canvas not available");
//         return;
//       }

//       const isEmpty = signatureCanvasRef.current.isEmpty();
//       if (isEmpty) {
//         showToast("warning", "Warning", "Please draw a signature first");
//         return;
//       }

//       const dataUrl = signatureCanvasRef.current.toDataURL("image/png");

//       const response = await fetch(dataUrl);
//       const blob = await response.blob();

//       const formData = new FormData();
//       formData.append("signature", blob, "signature.png");

//       const endpoint = `${url}/api/users/signature/${userData._id}`;
//       const method = signature?.hasSignature ? "put" : "post";

//       console.log("Saving signature to:", endpoint, "Method:", method);

//       const res = await axios[method](endpoint, formData, {
//         headers: { 
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "multipart/form-data"
//         }
//       });

//       console.log("Signature save response:", res.data);

//       if (res.data?.data) {
//         const signatureData = res.data.data;
//         const fullSignaturePath = getFullImageUrl(signatureData.signaturePath || signatureData.signature);

//         setSignature({
//           ...signatureData,
//           signature: fullSignaturePath,
//           hasSignature: true
//         });
//         setSignatureModalOpen(false);
//         showToast("success", "Success", "Signature saved successfully");
//       }

//     } catch (err) {
//       console.error("Signature save error:", err);
//       showToast("error", "Error", "Failed to save signature");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const clearSignature = () => {
//     if (signatureCanvasRef.current) {
//       signatureCanvasRef.current.clear();
//     }
//   };

//   const toggleFullscreen = () => {
//     setEditorFullscreen(!editorFullscreen);
//   };

//   const togglePreviewMode = () => {
//     const modes = ["live", "edit", "preview"];
//     const currentIndex = modes.indexOf(editorPreviewMode);
//     const nextIndex = (currentIndex + 1) % modes.length;
//     setEditorPreviewMode(modes[nextIndex]);
//   };

//   // Updated access control - allow both admins and engineers
//   if (!isAdmin && !canHaveSignature) {
//     return (
//       <Box sx={{ p: 3 }}>
//         <Typography color="error">Access Denied. Admin or Engineer privileges required.</Typography>
//       </Box>
//     );
//   }

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ p: { xs: 2, sm: 3 } }}>
//       {/* Toast Notification */}
//       {toast.open && (
//         <AppToast
//           open={toast.open}
//           type={toast.type}
//           title={toast.title}
//           message={toast.message}
//           onClose={() => setToast(prev => ({ ...prev, open: false }))}
//         />
//       )}

//       {/* Error/Success Messages */}
//       {error && (
//         <Alert severity="error" sx={{ mb: 2 }}>
//           {error}
//         </Alert>
//       )}
//       {success && (
//         <Alert severity="success" sx={{ mb: 2 }}>
//           {success}
//         </Alert>
//       )}

//       {/* Admin Information Card - Only for admins */}
//       {isAdmin && adminInfo && (
//         <Card sx={{ 
//           p: { xs: 2, sm: 3 }, 
//           mb: 3,
//           display: "flex", 
//           flexDirection: { xs: "column", sm: "row" },
//           justifyContent: "space-between", 
//           alignItems: { xs: "stretch", sm: "center" },
//           gap: { xs: 2, sm: 0 }
//         }}>
//           <Box sx={{ flex: 1 }}>
//             <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.PRIMARY, mb: 2 }}>
//               Admin Information
//             </Typography>
//             <Box sx={{ 
//               display: "flex", 
//               flexDirection: { xs: "column", sm: "row" },
//               flexWrap: "wrap",
//               gap: { xs: 2, sm: 4 }
//             }}>
//               <Box sx={{ minWidth: { xs: "100%", sm: "200px" } }}>
//                 <Typography variant="body2" color="text.secondary">Name</Typography>
//                 <Typography variant="body1">{adminInfo.name || "N/A"}</Typography>
//               </Box>
//               <Box sx={{ minWidth: { xs: "100%", sm: "200px" } }}>
//                 <Typography variant="body2" color="text.secondary">Email</Typography>
//                 <Typography variant="body1">{adminInfo.email || "N/A"}</Typography>
//               </Box>
//               <Box sx={{ minWidth: { xs: "100%", sm: "200px" } }}>
//                 <Typography variant="body2" color="text.secondary">Phone</Typography>
//                 <Typography variant="body1">{adminInfo.phone || "N/A"}</Typography>
//               </Box>
//             </Box>
//           </Box>
//           <Button 
//             variant="contained" 
//             onClick={openAdminModal}
//             sx={{ 
//               mt: { xs: 1, sm: 0 },
//               ml: { xs: 0, sm: 2 },
//               bgcolor: COLORS.SECONDARY, 
//               whiteSpace: 'nowrap',
//               alignSelf: { xs: "flex-start", sm: "center" }
//             }}
//           >
//             Update
//           </Button>
//         </Card>
//       )}

//       {/* Checklist Order Card - Only for admins */}
//       {isAdmin && (
//         <Card sx={{ 
//           p: { xs: 2, sm: 3 }, 
//           mb: 3,
//           display: "flex", 
//           flexDirection: { xs: "column", sm: "row" },
//           justifyContent: "space-between", 
//           alignItems: { xs: "stretch", sm: "center" },
//           gap: { xs: 2, sm: 0 }
//         }}>
//           <Box sx={{ flex: 1, pr: { xs: 0, sm: 2 } }}>
//             <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.PRIMARY, mb: 1 }}>
//               Checklist Templates Order
//             </Typography>
//             <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//               Change the display order of checklist templates. Drag and drop to reorder, then save.
//             </Typography>
//             {checklistTemplates.length > 0 && (
//               <Box sx={{ mt: 2 }}>
//                 <Typography variant="body2" color="text.secondary">
//                   Current order: {checklistTemplates.length} templates
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
//                   First: {checklistTemplates[0]?.title}
//                 </Typography>
//               </Box>
//             )}
//           </Box>
//           <Button 
//             variant="contained" 
//             onClick={openChecklistOrderModal}
//             sx={{ 
//               mt: { xs: 1, sm: 0 },
//               ml: { xs: 0, sm: 2 },
//               bgcolor: COLORS.SECONDARY,
//               alignSelf: { xs: "flex-start", sm: "center" }
//             }}
//           >
//             Change Order
//           </Button>
//         </Card>
//       )}

//       {/* Thank You Card - Only for admins */}
//       {isAdmin && (
//         <Card sx={{ 
//           p: { xs: 2, sm: 3 }, 
//           mb: 3,
//           display: "flex", 
//           flexDirection: { xs: "column", sm: "row" },
//           justifyContent: "space-between", 
//           alignItems: { xs: "stretch", sm: "center" },
//           gap: { xs: 2, sm: 0 }
//         }}>
//           <Box sx={{ flex: 1, pr: { xs: 0, sm: 2 } }}>
//             <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.PRIMARY, mb: 1 }}>
//               {thankYou.title || "Thank You Message"}
//             </Typography>
//             <Box sx={{ 
//               color: COLORS.TEXT,
//               '& h1, & h2, & h3, & h4, & h5, & h6': { 
//                 fontSize: '1rem !important',
//                 margin: '0.5rem 0'
//               },
//               '& p': { margin: '0.5rem 0' },
//               '& ul, & ol': { paddingLeft: '1.5rem' },
//               '& li': { margin: '0.25rem 0' }
//             }}>
//               <ReactMarkdown remarkPlugins={[remarkGfm]}>
//                 {truncate(thankYou.content, isMobile ? 100 : 150)}
//               </ReactMarkdown>
//             </Box>
//           </Box>
//           <Button 
//             variant="contained" 
//             onClick={() => openModal("THANK_YOU", "edit")}
//             sx={{ 
//               mt: { xs: 1, sm: 0 },
//               ml: { xs: 0, sm: 2 },
//               bgcolor: COLORS.SECONDARY,
//               alignSelf: { xs: "flex-start", sm: "center" }
//             }}
//           >
//             Update
//           </Button>
//         </Card>
//       )}

//       {/* Terms & Conditions Card - Only for admins */}
//       {isAdmin && (
//         <Card sx={{ 
//           p: { xs: 2, sm: 3 }, 
//           mb: 3,
//           display: "flex", 
//           flexDirection: { xs: "column", sm: "row" },
//           justifyContent: "space-between", 
//           alignItems: { xs: "stretch", sm: "center" },
//           gap: { xs: 2, sm: 0 }
//         }}>
//           <Box sx={{ flex: 1, pr: { xs: 0, sm: 2 } }}>
//             <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.PRIMARY, mb: 1 }}>
//               {terms.title || "Terms & Conditions"}
//             </Typography>
//             <Box sx={{ 
//               color: COLORS.TEXT,
//               '& h1, & h2, & h3, & h4, & h5, & h6': { 
//                 fontSize: '1rem !important',
//                 margin: '0.5rem 0'
//               },
//               '& p': { margin: '0.5rem 0' },
//               '& ul, & ol': { paddingLeft: '1.5rem' },
//               '& li': { margin: '0.25rem 0' }
//             }}>
//               <ReactMarkdown remarkPlugins={[remarkGfm]}>
//                 {truncate(terms.content, isMobile ? 80 : 100)}
//               </ReactMarkdown>
//             </Box>
//           </Box>
//           <Stack 
//             direction={{ xs: "column", sm: "row" }} 
//             spacing={1}
//             sx={{ 
//               mt: { xs: 1, sm: 0 },
//               ml: { xs: 0, sm: 2 },
//               alignSelf: { xs: "flex-start", sm: "center" }
//             }}
//           >
//             <Button 
//               variant="outlined" 
//               onClick={() => openModal("TERMS_CONDITIONS", "view")}
//               sx={{ minWidth: { xs: "100%", sm: "auto" } }}
//             >
//               View Full
//             </Button>
//             <Button 
//               variant="contained" 
//               onClick={() => openModal("TERMS_CONDITIONS", "edit")}
//               sx={{ 
//                 bgcolor: COLORS.SECONDARY,
//                 minWidth: { xs: "100%", sm: "auto" }
//               }}
//             >
//               Update
//             </Button>
//           </Stack>
//         </Card>
//       )}

//       {/* Signature Card - For both ADMINS and ENGINEERS */}
//       {canHaveSignature && (
//         <Card sx={{ 
//           p: { xs: 2, sm: 3 },
//           mb: 3,
//           display: "flex", 
//           flexDirection: { xs: "column", sm: "row" },
//           justifyContent: "space-between", 
//           alignItems: { xs: "stretch", sm: "center" },
//           gap: { xs: 2, sm: 0 }
//         }}>
//           <Box sx={{ flex: 1, pr: { xs: 0, sm: 2 } }}>
//             <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.PRIMARY, mb: 1 }}>
//               Signature ({userData?.role})
//             </Typography>
//             {signature?.hasSignature ? (
//               <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, alignItems: { xs: "flex-start", sm: "center" }, gap: 2 }}>
//                 <Box sx={{ 
//                   height: 60, 
//                   display: 'flex', 
//                   alignItems: 'center', 
//                   justifyContent: 'center',
//                   border: "1px solid #ddd", 
//                   borderRadius: 4,
//                   padding: 1,
//                   backgroundColor: '#fff',
//                   minWidth: 120
//                 }}>
//                   <img 
//                     src={signature.signature} 
//                     alt="Signature" 
//                     style={{ 
//                       maxHeight: '100%',
//                       maxWidth: '100%',
//                       objectFit: 'contain',
//                     }}
//                     onError={(e) => {
//                       console.error("Signature image failed to load:", signature.signature);
//                       e.target.style.display = 'none';
//                       const parent = e.target.parentElement;
//                       if (parent) {
//                         const fallbackText = document.createElement('div');
//                         fallbackText.textContent = 'Signature';
//                         fallbackText.style.color = COLORS.TEXT;
//                         fallbackText.style.fontSize = '12px';
//                         parent.appendChild(fallbackText);
//                       }
//                     }}
//                   />
//                 </Box>
//                 <Box>
//                   <Typography variant="body2" color="text.secondary">
//                     Last updated: {signature.createdAt ? new Date(signature.createdAt).toLocaleDateString("en-GB", {
//   day: "2-digit",
//   month: "2-digit",
//   year: "2-digit",
// }).replace(/\//g, '/') : "N/A"}
//                   </Typography>
//                   <Typography variant="caption" color="text.secondary">
//                     User: {signature.userName || userData?.name}
//                   </Typography>
//                 </Box>
//               </Box>
//             ) : (
//               <Box>
//                 <Typography variant="body1" color="text.secondary">
//                   No signature added yet
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   {userData?.role === "ENGINEER" 
//                     ? "Add your signature to sign site checklists" 
//                     : "Add your signature for admin purposes"}
//                 </Typography>
//               </Box>
//             )}
//           </Box>
//           <Button 
//             variant="contained" 
//             onClick={() => setSignatureModalOpen(true)}
//             sx={{ 
//               mt: { xs: 1, sm: 0 },
//               ml: { xs: 0, sm: 2 },
//               bgcolor: COLORS.SECONDARY,
//               alignSelf: { xs: "flex-start", sm: "center" }
//             }}
//           >
//             {signature?.hasSignature ? "Update Signature" : "Add Signature"}
//           </Button>
//         </Card>
//       )}

//       {/* Checklist Order Modal - Only for admins */}
//       <Modal 
//         open={checklistOrderModalOpen} 
//         onClose={() => !isUpdatingOrder && setChecklistOrderModalOpen(false)}
//       >
//         <Box sx={{
//           position: 'absolute',
//           top: '50%',
//           left: '50%',
//           transform: 'translate(-50%, -50%)',
//           width: { xs: '95vw', md: '80vw' },
//           height: { xs: '95vh', md: '90vh' },
//           bgcolor: 'background.paper',
//           boxShadow: 24,
//           p: { xs: 2, sm: 3 },
//           overflow: 'hidden',
//           display: 'flex',
//           flexDirection: 'column',
//           borderRadius: 2
//         }}>
//           {/* Header */}
//           <Box sx={{ 
//             display: "flex", 
//             justifyContent: "space-between", 
//             alignItems: "center", 
//             mb: 3,
//             flexShrink: 0
//           }}>
//             <Typography sx={{ 
//               ...TYPOGRAPHY.H3, 
//               fontSize: { xs: '1.25rem', sm: '1.5rem' }
//             }}>
//               Change Checklist Templates Order
//             </Typography>
//             <IconButton 
//               onClick={() => !isUpdatingOrder && setChecklistOrderModalOpen(false)} 
//               disabled={isUpdatingOrder}
//             >
//               <Icon name="close" />
//             </IconButton>
//           </Box>

//           {/* Instructions */}
//           <Typography variant="body2" color="text.secondary" sx={{ mb: 3, flexShrink: 0 }}>
//             Drag and drop checklist templates to reorder them. The order will be saved when you click "Save Order".
//             Templates are initially sorted by creation date (oldest first).
//           </Typography>

//           {/* Checklist Templates List */}
//           <Paper 
//             sx={{ 
//               flex: 1, 
//               overflow: 'auto', 
//               mb: 3,
//               p: 2,
//               bgcolor: '#f9f9f9'
//             }}
//           >
//             <List sx={{ width: '100%' }}>
//               {checklistTemplates.map((template, index) => (
//                 <React.Fragment key={template._id}>
//                   <ListItem
//                     sx={{
//                       mb: 1,
//                       bgcolor: 'white',
//                       borderRadius: 1,
//                       border: '1px solid #e0e0e0',
//                       cursor: 'move',
//                       userSelect: 'none',
//                       transition: 'all 0.2s ease',
//                       opacity: draggedItem === index ? 0.5 : 1,
//                       backgroundColor: dropTarget === index ? '#e3f2fd' : 'white',
//                       boxShadow: draggedItem === index ? 2 : 0,
//                       '&:hover': {
//                         boxShadow: 2,
//                       }
//                     }}
//                     draggable
//                     onDragStart={(e) => handleDragStart(e, index)}
//                     onDragOver={(e) => handleDragOver(e, index)}
//                     onDragEnd={handleDragEnd}
//                     onDrop={(e) => handleDrop(e, index)}
//                   >
//                     <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
//                       <Box sx={{ 
//                         display: 'flex', 
//                         alignItems: 'center', 
//                         justifyContent: 'center',
//                         mr: 2,
//                         minWidth: 30
//                       }}>
//                         <Icon name="grip-vertical" color={COLORS.LIGHT_SECONDARY} size={20} />
//                       </Box>

//                       <Box sx={{ 
//                         display: 'flex', 
//                         alignItems: 'center', 
//                         mr: 2,
//                         minWidth: 40
//                       }}>
//                         <Typography 
//                           sx={{ 
//                             ...TYPOGRAPHY.BODY_LARGE, 
//                             fontWeight: 'bold',
//                             color: COLORS.PRIMARY
//                           }}
//                         >
//                           {index + 1}.
//                         </Typography>
//                       </Box>

//                       <ListItemText
//                         primary={
//                           <Typography sx={{ ...TYPOGRAPHY.BODY_LARGE, color: COLORS.PRIMARY }}>
//                             {template.title}
//                           </Typography>
//                         }
//                         secondary={
//                           <Box>
//                             <Typography variant="body2" color="text.secondary">
//                               Created: {new Date(template.createdAt).toLocaleDateString("en-GB", {
//   day: "2-digit",
//   month: "2-digit",
//   year: "2-digit",
// }).replace(/\//g, '/')}
//                             </Typography>
//                             {template.description && (
//                               <Typography variant="body2" color="text.secondary">
//                                 {truncate(template.description, 100)}
//                               </Typography>
//                             )}
//                           </Box>
//                         }
//                       />

//                       <ListItemSecondaryAction>
//                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                           <Typography variant="body2" color="text.secondary" sx={{ mr: 2 }}>
//                             {template.isActive ? 'Active' : 'Inactive'}
//                           </Typography>
//                           <Typography variant="body2" color="text.secondary">
//                             Sections: {template.sections?.length || 0}
//                           </Typography>
//                         </Box>
//                       </ListItemSecondaryAction>
//                     </Box>
//                   </ListItem>
//                   {index < checklistTemplates.length - 1 && (
//                     <Divider sx={{ mb: 1 }} />
//                   )}
//                 </React.Fragment>
//               ))}

//               {checklistTemplates.length === 0 && (
//                 <Box sx={{ 
//                   display: 'flex', 
//                   flexDirection: 'column', 
//                   alignItems: 'center', 
//                   justifyContent: 'center',
//                   py: 8
//                 }}>
//                   <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
//                     No checklist templates found
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Create checklist templates first to reorder them
//                   </Typography>
//                 </Box>
//               )}
//             </List>
//           </Paper>

//           {/* Footer */}
//           <Box sx={{ 
//             display: "flex", 
//             justifyContent: "space-between", 
//             alignItems: "center", 
//             pt: 2, 
//             borderTop: 1, 
//             borderColor: 'divider',
//             flexShrink: 0
//           }}>
//             <Typography variant="body2" color="text.secondary">
//               Total: {checklistTemplates.length} templates
//             </Typography>

//             <Box sx={{ display: "flex", gap: 2 }}>
//               <Button 
//                 onClick={() => setChecklistOrderModalOpen(false)} 
//                 variant="outlined"
//                 disabled={isUpdatingOrder}
//                 sx={{ minWidth: { xs: '80px', sm: '100px' } }}
//               >
//                 Cancel
//               </Button>
//               <Button 
//                 onClick={saveChecklistOrder} 
//                 variant="contained" 
//                 disabled={isUpdatingOrder || checklistTemplates.length === 0}
//                 sx={{ 
//                   bgcolor: COLORS.SECONDARY,
//                   minWidth: { xs: '80px', sm: '120px' }
//                 }}
//               >
//                 {isUpdatingOrder ? (
//                   <>
//                     <CircularProgress size={20} sx={{ mr: 1 }} />
//                     Saving...
//                   </>
//                 ) : (
//                   'Save Order'
//                 )}
//               </Button>
//             </Box>
//           </Box>
//         </Box>
//       </Modal>

//       {/* Content Modal - Only for admins */}
//       <Modal 
//         open={modalOpen} 
//         onClose={() => !saving && setModalOpen(false)}
//         sx={{
//           '& .MuiBackdrop-root': {
//             backgroundColor: editorFullscreen ? 'rgba(0, 0, 0, 0.9)' : 'rgba(0, 0, 0, 0.5)'
//           }
//         }}
//       >
//         <Box sx={{
//           position: 'absolute',
//           top: '50%',
//           left: '50%',
//           transform: 'translate(-50%, -50%)',
//           width: editorFullscreen ? '100vw' : { xs: '95vw', md: '90vw' },
//           height: editorFullscreen ? '100vh' : { xs: '95vh', md: '90vh' },
//           bgcolor: 'background.paper',
//           boxShadow: editorFullscreen ? 'none' : 24,
//           p: editorFullscreen ? 0 : { xs: 2, sm: 4 },
//           overflow: 'hidden',
//           display: 'flex',
//           flexDirection: 'column',
//           borderRadius: editorFullscreen ? 0 : 2
//         }}>
//           {/* Header with controls */}
//           <Box sx={{ 
//             display: "flex", 
//             justifyContent: "space-between", 
//             alignItems: "center", 
//             mb: 3,
//             p: editorFullscreen ? 2 : 0,
//             borderBottom: editorFullscreen ? '1px solid #ddd' : 'none',
//             backgroundColor: editorFullscreen ? '#f5f5f5' : 'transparent'
//           }}>
//             <Typography sx={{ 
//               ...TYPOGRAPHY.H3, 
//               fontSize: { xs: '1.25rem', sm: '1.5rem' },
//               color: editorFullscreen ? '#000' : 'inherit'
//             }}>
//               {modalMode === "view" ? "View" : "Edit"} - {activeType === "THANK_YOU" ? "Thank You" : "Terms & Conditions"}
//             </Typography>

//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               {modalMode === "edit" && (
//                 <>
//                   <Button
//                     variant="outlined"
//                     size="small"
//                     onClick={togglePreviewMode}
//                     sx={{ 
//                       minWidth: 'auto',
//                       px: 1,
//                       fontSize: '0.75rem'
//                     }}
//                   >
//                     {editorPreviewMode === "live" && "Split View"}
//                     {editorPreviewMode === "edit" && "Edit Only"}
//                     {editorPreviewMode === "preview" && "Preview Only"}
//                   </Button>

//                   <Button
//                     variant="outlined"
//                     size="small"
//                     onClick={toggleFullscreen}
//                     sx={{ 
//                       minWidth: 'auto',
//                       px: 1,
//                       fontSize: '0.75rem'
//                     }}
//                   >
//                     {editorFullscreen ? "Exit Fullscreen" : "Fullscreen"}
//                   </Button>
//                 </>
//               )}

//               <IconButton 
//                 onClick={() => !saving && setModalOpen(false)} 
//                 disabled={saving}
//                 sx={{ 
//                   color: editorFullscreen ? '#000' : 'inherit'
//                 }}
//               >
//                 <Icon name="close" />
//               </IconButton>
//             </Box>
//           </Box>

//           {modalMode === "edit" && (
//             <TextField
//               fullWidth
//               label="Title"
//               value={tempData.title}
//               onChange={e => setTempData({ ...tempData, title: e.target.value })}
//               sx={{ 
//                 mb: 3,
//                 px: editorFullscreen ? 2 : 0
//               }}
//               disabled={saving}
//             />
//           )}

//           {/* Content Area - SIMPLIFIED EDITOR */}
//           {modalMode === "edit" ? (
//             <Box sx={{ 
//               flex: 1, 
//               overflow: 'hidden',
//               mb: 2,
//               px: editorFullscreen ? 2 : 0,
//               '& .w-md-editor': {
//                 height: '100% !important',
//                 border: '1px solid #ddd',
//                 borderRadius: 1
//               },
//               '& .w-md-editor-content': {
//                 height: 'calc(100% - 40px) !important'
//               }
//             }}>
//               <MDEditor
//                 value={tempData.content}
//                 onChange={(value) => setTempData({ ...tempData, content: value || "" })}
//                 height="100%"
//                 preview={editorPreviewMode}
//                 visibleDragbar={editorPreviewMode === "live"}
//                 textareaProps={{
//                   placeholder: `Enter ${activeType === "THANK_YOU" ? "Thank You" : "Terms & Conditions"} content here...`,
//                 }}
//               />
//             </Box>
//           ) : (
//             <Box sx={{ 
//               flex: 1, 
//               overflow: 'auto', 
//               p: 2, 
//               bgcolor: '#f5f5f5', 
//               borderRadius: 1, 
//               mb: 2,
//               mx: editorFullscreen ? 2 : 0
//             }}>
//               <Box sx={{
//                 '& h1': { fontSize: '1.8rem', margin: '1rem 0', fontWeight: 'bold' },
//                 '& h2': { fontSize: '1.5rem', margin: '0.8rem 0', fontWeight: 'bold' },
//                 '& h3': { fontSize: '1.3rem', margin: '0.6rem 0', fontWeight: 'bold' },
//                 '& h4': { fontSize: '1.1rem', margin: '0.5rem 0', fontWeight: 'bold' },
//                 '& p': { margin: '0.5rem 0', lineHeight: '1.6' },
//                 '& ul, & ol': { paddingLeft: '2rem', margin: '0.5rem 0' },
//                 '& li': { margin: '0.3rem 0', lineHeight: '1.5' },
//                 '& blockquote': { 
//                   borderLeft: '4px solid #ddd', 
//                   paddingLeft: '1rem', 
//                   margin: '1rem 0',
//                   color: '#666',
//                   fontStyle: 'italic'
//                 },
//                 '& code': { 
//                   backgroundColor: '#f0f0f0', 
//                   padding: '0.2rem 0.4rem', 
//                   borderRadius: '3px',
//                   fontFamily: 'monospace'
//                 },
//                 '& pre': { 
//                   backgroundColor: '#f5f5f5', 
//                   padding: '1rem', 
//                   borderRadius: '4px',
//                   overflow: 'auto'
//                 },
//                 '& table': { 
//                   borderCollapse: 'collapse', 
//                   width: '100%',
//                   margin: '1rem 0'
//                 },
//                 '& th, & td': { 
//                   border: '1px solid #ddd', 
//                   padding: '0.5rem',
//                   textAlign: 'left'
//                 },
//                 '& th': { 
//                   backgroundColor: '#f0f0f0',
//                   fontWeight: 'bold'
//                 }
//               }}>
//                 <ReactMarkdown remarkPlugins={[remarkGfm]}>
//                   {tempData.content}
//                 </ReactMarkdown>
//               </Box>
//             </Box>
//           )}

//           {modalMode === "edit" && (
//             <Box sx={{ 
//               display: "flex", 
//               justifyContent: "flex-end", 
//               gap: 2, 
//               mt: 2, 
//               pt: 2, 
//               borderTop: 1, 
//               borderColor: 'divider',
//               px: editorFullscreen ? 2 : 0
//             }}>
//               <Button 
//                 onClick={() => setModalOpen(false)} 
//                 variant="outlined"
//                 disabled={saving}
//                 sx={{ minWidth: { xs: '80px', sm: '100px' } }}
//               >
//                 Cancel
//               </Button>
//               <Button 
//                 onClick={save} 
//                 variant="contained" 
//                 disabled={saving}
//                 sx={{ 
//                   bgcolor: COLORS.SECONDARY,
//                   minWidth: { xs: '80px', sm: '100px' }
//                 }}
//               >
//                 {saving ? <CircularProgress size={24} /> : "Save"}
//               </Button>
//             </Box>
//           )}
//         </Box>
//       </Modal>

//       {/* Admin Info Modal - Only for admins */}
//       {isAdmin && (
//         <Modal open={adminModalOpen} onClose={() => !saving && setAdminModalOpen(false)}>
//           <Box sx={{
//             position: 'absolute',
//             top: '50%',
//             left: '50%',
//             transform: 'translate(-50%, -50%)',
//             width: { xs: '90vw', sm: 500 },
//             maxWidth: '95vw',
//             bgcolor: 'background.paper',
//             boxShadow: 24,
//             p: { xs: 2, sm: 4 },
//             borderRadius: 2
//           }}>
//             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//               <Typography sx={{ ...TYPOGRAPHY.H3, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
//                 Update Admin Information
//               </Typography>
//               <IconButton onClick={() => !saving && setAdminModalOpen(false)} disabled={saving}>
//                 <Icon name="close" />
//               </IconButton>
//             </Box>

//             <Stack spacing={3}>
//               <TextField
//                 fullWidth
//                 label="Name"
//                 value={tempAdminInfo.name}
//                 onChange={e => setTempAdminInfo({ ...tempAdminInfo, name: e.target.value })}
//                 disabled={saving}
//               />
//               <TextField
//                 fullWidth
//                 label="Email"
//                 type="email"
//                 value={tempAdminInfo.email}
//                 onChange={e => setTempAdminInfo({ ...tempAdminInfo, email: e.target.value })}
//                 disabled={saving}
//               />
//               <TextField
//                 fullWidth
//                 label="Phone"
//                 value={tempAdminInfo.phone}
//                 onChange={e => setTempAdminInfo({ ...tempAdminInfo, phone: e.target.value })}
//                 disabled={saving}
//               />
//             </Stack>

//             <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 4 }}>
//               <Button 
//                 onClick={() => setAdminModalOpen(false)} 
//                 variant="outlined"
//                 disabled={saving}
//                 sx={{ minWidth: { xs: '80px', sm: '100px' } }}
//               >
//                 Cancel
//               </Button>
//               <Button 
//                 onClick={saveAdminInfo} 
//                 variant="contained" 
//                 disabled={saving}
//                 sx={{ 
//                   bgcolor: COLORS.SECONDARY,
//                   minWidth: { xs: '80px', sm: '100px' }
//                 }}
//               >
//                 {saving ? <CircularProgress size={24} /> : "Update"}
//               </Button>
//             </Box>
//           </Box>
//         </Modal>
//       )}

//       {/* Signature Modal - For both ADMINS and ENGINEERS */}
//       <Modal open={signatureModalOpen} onClose={() => !saving && setSignatureModalOpen(false)}>
//         <Box sx={{
//           position: 'absolute',
//           top: '50%',
//           left: '50%',
//           transform: 'translate(-50%, -50%)',
//           width: { xs: '95vw', sm: 600 },
//           maxWidth: '95vw',
//           bgcolor: 'background.paper',
//           boxShadow: 24,
//           p: { xs: 2, sm: 4 },
//           borderRadius: 2
//         }}>
//           <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
//             <Typography sx={{ ...TYPOGRAPHY.H3, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
//               {signature?.hasSignature ? "Update Signature" : "Add Signature"} ({userData?.role})
//             </Typography>
//             <IconButton onClick={() => !saving && setSignatureModalOpen(false)} disabled={saving}>
//               <Icon name="close" />
//             </IconButton>
//           </Box>

//           <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//             {userData?.role === "ENGINEER" 
//               ? "Draw your signature below. This signature will be used to sign site checklists and reports." 
//               : "Draw your signature in the area below. Use mouse on desktop or finger/stylus on touch devices."}
//           </Typography>

//           <SignatureCanvas
//             ref={signatureCanvasRef}
//             height={200}
//           />

//           <Box sx={{ 
//             display: "flex", 
//             flexDirection: { xs: "column", sm: "row" },
//             justifyContent: "space-between", 
//             gap: 2, 
//             mt: 3 
//           }}>
//             <Button 
//               onClick={clearSignature} 
//               variant="outlined" 
//               color="error"
//               disabled={saving}
//               sx={{ 
//                 minWidth: { xs: '100%', sm: 'auto' },
//                 order: { xs: 2, sm: 1 }
//               }}
//             >
//               Clear
//             </Button>
//             <Box sx={{ 
//               display: "flex", 
//               flexDirection: { xs: "column", sm: "row" },
//               gap: 2,
//               order: { xs: 1, sm: 2 },
//               width: { xs: '100%', sm: 'auto' }
//             }}>
//               <Button 
//                 onClick={() => setSignatureModalOpen(false)} 
//                 variant="outlined"
//                 disabled={saving}
//                 sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
//               >
//                 Cancel
//               </Button>
//               <Button 
//                 onClick={saveSignature} 
//                 variant="contained" 
//                 disabled={saving}
//                 sx={{ 
//                   bgcolor: COLORS.SECONDARY,
//                   minWidth: { xs: '100%', sm: 'auto' }
//                 }}
//               >
//                 {saving ? <CircularProgress size={24} /> : "Save Signature"}
//               </Button>
//             </Box>
//           </Box>
//         </Box>
//       </Modal>
//     </Box>
//   );
// };

// export default GeneralSettings;
import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Card,
  Button,
  Alert,
  CircularProgress,
  Modal,
  IconButton,
  Stack,
  TextField,
  useMediaQuery,
  useTheme,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Paper,
  Divider,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import { Icon } from "../../icons";
import { COLORS, TYPOGRAPHY, FONT_FAMILY } from "../../constants/color";
import { useAuth } from "../../context/authContext";
import axios from "axios";
import { url } from "../../constants/url";

// Simple MDEditor import
import MDEditor from '@uiw/react-md-editor';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import SignatureCanvas from "../../components/siteCheck/SignatureCanvas";
import AppToast from "../../components/AppToast";

const truncate = (text, length = 250) =>
  text?.length > length ? text.substring(0, length) + "..." : text;

// Helper function to get full image URL
const getFullImageUrl = (imagePath) => {
  if (!imagePath) return null;

  // If it's already a full URL or data URL, return it as is
  if (
    imagePath.startsWith('http://') || 
    imagePath.startsWith('https://') || 
    imagePath.startsWith('data:image')
  ) {
    return imagePath;
  }

  // Clean the path - replace backslashes with forward slashes
  let cleanPath = imagePath.replace(/\\/g, '/');
  
  // Remove leading slash if present
  cleanPath = cleanPath.startsWith('/') ? cleanPath.substring(1) : cleanPath;

  // Ensure the URL is correctly constructed
  const baseUrl = url.endsWith('/') ? url.slice(0, -1) : url;
  
  return `${baseUrl}/${cleanPath}`;
};

const GeneralSettings = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { token, userData } = useAuth();

  console.log("UserData from auth:", userData);
  console.log("User role:", userData?.role);

  const isAdmin = userData?.role === "ADMIN" || userData?.role === "SUPERADMIN";
  // Update: Engineers can also have signatures
  const canHaveSignature = userData?.role === "ADMIN" || userData?.role === "ENGINEER" || userData?.role === "SUPERADMIN";

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const [thankYou, setThankYou] = useState({ _id: "", title: "", content: "" });
  const [terms, setTerms] = useState({ _id: "", title: "", content: "" });
  const [clientNotification, setClientNotification] = useState({ _id: "", title: "", content: "" });
  const [companyInfo, setCompanyInfo] = useState(null);
  const [signature, setSignature] = useState(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("view");
  const [activeType, setActiveType] = useState("THANK_YOU");
  const [tempData, setTempData] = useState({ title: "", content: "" });

  const [signatureModalOpen, setSignatureModalOpen] = useState(false);
  const [signatureError, setSignatureError] = useState(false);
  const [companyModalOpen, setCompanyModalOpen] = useState(false);
  const [tempCompanyInfo, setTempCompanyInfo] = useState({
    name: "",
    email: "",
    phone: "",
    street: "",
    city: "",
    state: "",
    zipCode: "",
    gstNumber: "",
    invoiceNumberPrefix: "",
  });

  const [mainPortalStats, setMainPortalStats] = useState({ totalClients: 0, totalEngineers: 0, pendingProjects: 0, completedProjects: 0, totalRequested: 0 });
  const [mainPortalStatsModalOpen, setMainPortalStatsModalOpen] = useState(false);
  const [tempMainPortalStats, setTempMainPortalStats] = useState({ totalClients: 0, totalEngineers: 0, pendingProjects: 0, completedProjects: 0, totalRequested: 0 });

  // New state for checklist order management
  const [checklistOrderModalOpen, setChecklistOrderModalOpen] = useState(false);
  const [checklistTemplates, setChecklistTemplates] = useState([]);
  const [draggedItem, setDraggedItem] = useState(null);
  const [dropTarget, setDropTarget] = useState(null);
  const [isUpdatingOrder, setIsUpdatingOrder] = useState(false);

  const signatureCanvasRef = useRef(null);
  const [editorFullscreen, setEditorFullscreen] = useState(false);
  const [editorPreviewMode, setEditorPreviewMode] = useState("live"); // live, edit, preview

  // Toast state
  const [toast, setToast] = useState({
    open: false,
    type: "success",
    title: "",
    message: ""
  });

  // Show toast function
  const showToast = (type, title, message) => {
    setToast({
      open: true,
      type,
      title,
      message
    });
    setTimeout(() => {
      setToast(prev => ({ ...prev, open: false }));
    }, 5000);
  };

  useEffect(() => {
    if (isAdmin) {
      fetchData();
    } else {
      // For engineers, just set loading to false
      setLoading(false);
    }
  }, [isAdmin, token, userData?.role]);

  useEffect(() => {
    console.log("📋 Signature useEffect triggered");
    console.log("User role:", userData?.role);
    console.log("Can have signature:", canHaveSignature);
    console.log("User ID:", userData?._id);

    if (canHaveSignature && userData?._id) {
      console.log("✅ Fetching signature for user:", userData._id);
      fetchSignature();
    } else {
      console.log("❌ Cannot fetch signature:");
      if (!canHaveSignature) console.log("  - User role not allowed:", userData?.role);
      if (!userData?._id) console.log("  - No user ID");
    }
  }, [canHaveSignature, userData, token]);

  const fetchData = async () => {
    try {
      setLoading(true);

      // Only admins can fetch these settings
      if (isAdmin) {
        // Fetch Thank You content
        const tyResponse = await axios.get(`${url}/api/general/content/THANK_YOU`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        console.log("Thank You API Response:", tyResponse.data);

        // Fetch Terms & Conditions content  
        const tcResponse = await axios.get(`${url}/api/general/content/TERMS_CONDITIONS`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        console.log("Terms API Response:", tcResponse.data);

        // Fetch Client Notification text
        const cnResponse = await axios.get(`${url}/api/general/content/CLIENT_NOTIFICATION`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        console.log("Client Notification API Response:", cnResponse.data);

        // Fetch company details directly from company API
        const companyResponse = await axios.get(`${url}/api/company/fetch`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        console.log("Company API Response:", companyResponse.data);

        // Fetch admin user data (as fallback / to get adminUserId)
        const adminResponse = await axios.get(`${url}/api/users/fetch?role=ADMIN&limit=1`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        console.log("Admin API Response:", adminResponse.data);

        // Handle Thank You data
        if (tyResponse.data?.data) {
          const tyData = tyResponse.data.data;
          const data = Array.isArray(tyData) ? tyData[0] : tyData;
          setThankYou({
            _id: data?._id || "",
            title: data?.title || "Thank You Message",
            content: data?.content || ""
          });
        }

        // Handle Terms & Conditions data
        if (tcResponse.data?.data) {
          const tcData = tcResponse.data.data;
          const data = Array.isArray(tcData) ? tcData[0] : tcData;
          setTerms({
            _id: data?._id || "",
            title: data?.title || "Terms & Conditions",
            content: data?.content || ""
          });
        }

        // Handle Client Notification data
        if (cnResponse.data?.data) {
          const cnData = cnResponse.data.data;
          const data = Array.isArray(cnData) ? cnData[0] : cnData;
          setClientNotification({
            _id: data?._id || "",
            title: data?.title || "Client Notification Banner",
            content: data?.content || "Normal credits are used only upto 35 to 40 km range only \nFor outstation visits above 40 km , please select the outstation option."
          });
        }

        const adminData = adminResponse.data?.users?.[0] || null;

        // Handle Company data
        if (companyResponse.data?.data && companyResponse.data.data.length > 0) {
          const companyData = companyResponse.data.data[0];
          setCompanyInfo({
            _id: companyData._id,
            name: companyData.name || "",
            email: companyData.email || "",
            phone: companyData.phone || "",
            street: companyData.address?.street || "",
            city: companyData.address?.city || "",
            state: companyData.address?.state || "",
            zipCode: companyData.address?.zipCode || "",
            gstNumber: companyData.gstNumber || "",
            invoiceNumberPrefix: companyData.invoiceNumberPrefix || "",
            adminUserId: adminData?._id || null,
            isFromUserData: false
          });
        } else if (adminData) {
          // Fallback: Use admin user data if company details not found
          console.warn("Company details not found in database, using admin user data as fallback");
          setCompanyInfo({
            _id: adminData._id,
            name: adminData.name || "",
            email: adminData.email || "",
            phone: adminData.phone || "",
            street: "",
            city: "",
            state: "",
            zipCode: "",
            gstNumber: "",
            invoiceNumberPrefix: "",
            adminUserId: adminData._id,
            isFromUserData: true // Flag to indicate this is user data, not company data
          });
        }
        
        // Fetch Main Portal Dummy Stats
        const mpStatsResponse = await axios.get(`${url}/api/dummy-stats/main-portal`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (mpStatsResponse.data?.success) {
          setMainPortalStats(mpStatsResponse.data.data);
        }
      }

      setError(null);
    } catch (err) {
      console.error("Fetch error:", err);
      setError("Failed to fetch data. Please check console for details.");
      showToast("error", "Error", "Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const fetchSignature = async () => {
    try {
      if (!userData?._id) {
        console.log("No user ID available");
        return;
      }

      console.log("Fetching signature for user ID:", userData._id);
      console.log("User role for signature:", userData?.role);

      const res = await axios.get(`${url}/api/users/signature/${userData._id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      console.log("Signature API Response:", res.data);

      if (res.data?.data) {
        const signatureData = res.data.data;
        const signaturePath = signatureData.signaturePath || signatureData.signature;
        
        if (signaturePath) {
          const fullSignaturePath = getFullImageUrl(signaturePath);

          console.log("Full signature URL resolved:", fullSignaturePath);
          setSignatureError(false);
          setSignature({
            ...signatureData,
            signature: fullSignaturePath,
            hasSignature: true
          });
        } else {
          setSignatureError(true);
          setSignature(null);
        }
      } else if (res.data?.message === "No signature found for this user") {
        setSignature(null);
        setSignatureError(false);
      } else {
        console.log("Unexpected response format");
        setSignature(null);
      }
    } catch (err) {
      console.error("Signature fetch error:", err);
      console.error("Error status:", err.response?.status);
      console.error("Error data:", err.response?.data);
      if (err.response?.status !== 404) {
        console.error("Error fetching signature:", err);
      }
      setSignature(null);
    }
  };

  // New function to fetch checklist templates
  const fetchChecklistTemplates = async () => {
    try {
      console.log("Fetching checklist templates...");

      const res = await axios.get(`${url}/api/admin/checklist-templates`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          sort: 'oldest', // Get in ascending order by creation date
          limit: 100 // Get all templates
        }
      });

      console.log("Checklist templates response:", res.data);

      if (res.data?.data) {
        // Sort by createdAt ascending (oldest first)
        const sortedTemplates = [...res.data.data].sort((a, b) => {
          return new Date(a.createdAt) - new Date(b.createdAt);
        });

        setChecklistTemplates(sortedTemplates);
        showToast("success", "Success", "Checklist templates loaded successfully");
      }
    } catch (err) {
      console.error("Error fetching checklist templates:", err);
      showToast("error", "Error", "Failed to load checklist templates");
    }
  };

  // New function to open checklist order modal
  const openChecklistOrderModal = async () => {
    try {
      setChecklistOrderModalOpen(true);
      await fetchChecklistTemplates();
    } catch (err) {
      console.error("Error opening checklist order modal:", err);
    }
  };

  // Drag and drop handlers
  const handleDragStart = (e, index) => {
    e.dataTransfer.effectAllowed = "move";
    e.currentTarget.style.opacity = "0.5";
    setDraggedItem(index);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "move";
    setDropTarget(index);
  };

  const handleDragEnd = (e) => {
    e.currentTarget.style.opacity = "1";
    setDraggedItem(null);
    setDropTarget(null);
  };

  const handleDrop = (e, targetIndex) => {
    e.preventDefault();
    e.stopPropagation();

    if (draggedItem === null || draggedItem === targetIndex) {
      setDraggedItem(null);
      setDropTarget(null);
      return;
    }

    // Reorder the checklist templates
    const updatedTemplates = [...checklistTemplates];
    const [draggedTemplate] = updatedTemplates.splice(draggedItem, 1);
    updatedTemplates.splice(targetIndex, 0, draggedTemplate);

    // Update serial numbers based on new order
    const renumberedTemplates = updatedTemplates.map((template, index) => ({
      ...template,
      displayOrder: index + 1
    }));

    setChecklistTemplates(renumberedTemplates);
    setDraggedItem(null);
    setDropTarget(null);

    showToast("info", "Order Changed", "Drag to reorder, click Save to apply changes");
  };

  // Save the new order
  const saveChecklistOrder = async () => {
    try {
      setIsUpdatingOrder(true);

      // Prepare the order data
      const orderData = checklistTemplates.map((template, index) => ({
        _id: template._id,
        title: template.title,
        displayOrder: index + 1
      }));

      console.log("Saving checklist order:", orderData);

      // You'll need to create an API endpoint for this
      const res = await axios.put(`${url}/api/general/checklist-order`,
        { templates: orderData },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      console.log("Save order response:", res.data);

      if (res.data?.success) {
        showToast("success", "Success", "Checklist order saved successfully");
        setChecklistOrderModalOpen(false);
      } else {
        throw new Error(res.data?.message || "Failed to save order");
      }
    } catch (err) {
      console.error("Error saving checklist order:", err);
      showToast("error", "Error", err.response?.data?.message || "Failed to save checklist order");
    } finally {
      setIsUpdatingOrder(false);
    }
  };

  const openModal = (type, mode) => {
    let data;
    if (type === "THANK_YOU") data = thankYou;
    else if (type === "TERMS_CONDITIONS") data = terms;
    else if (type === "CLIENT_NOTIFICATION") data = clientNotification;

    setActiveType(type);
    setModalMode(mode);
    setTempData({
      _id: data._id,
      title: data.title || "",
      content: data.content || ""
    });
    setModalOpen(true);
    // Reset editor states
    setEditorFullscreen(false);
    setEditorPreviewMode("live");
  };

  const openCompanyModal = () => {
    if (companyInfo) {
      setTempCompanyInfo({
        name: companyInfo.name || "",
        email: companyInfo.email || "",
        phone: companyInfo.phone || "",
        street: companyInfo.street || "",
        city: companyInfo.city || "",
        state: companyInfo.state || "",
        zipCode: companyInfo.zipCode || "",
        gstNumber: companyInfo.gstNumber || "",
        invoiceNumberPrefix: companyInfo.invoiceNumberPrefix || "",
      });
    }
    setCompanyModalOpen(true);
  };

  const openMainPortalStatsModal = () => {
    if (mainPortalStats) {
      setTempMainPortalStats({
        totalClients: mainPortalStats.totalClients || 0,
        totalEngineers: mainPortalStats.totalEngineers || 0,
        pendingProjects: mainPortalStats.pendingProjects || 0,
        completedProjects: mainPortalStats.completedProjects || 0,
        totalRequested: mainPortalStats.totalRequested || 0
      });
    }
    setMainPortalStatsModalOpen(true);
  };

  const save = async () => {
    try {
      setSaving(true);

      const payload = {
        contentType: activeType,
        title: tempData.title,
        content: tempData.content,
        isActive: true
      };

      console.log("Saving payload:", payload);

      let res;
      if (tempData._id) {
        res = await axios.put(`${url}/api/general/content/${tempData._id}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        res = await axios.post(`${url}/api/general/content`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      console.log("Save response:", res.data);

      if (res.data?.data) {
        const savedData = res.data.data;
        if (activeType === "THANK_YOU") {
          setThankYou(savedData);
        } else if (activeType === "TERMS_CONDITIONS") {
          setTerms(savedData);
        } else if (activeType === "CLIENT_NOTIFICATION") {
          setClientNotification(savedData);
        }

        setModalOpen(false);
        showToast("success", "Success", "Content saved successfully");
        setError(null);
      }

    } catch (err) {
      console.error("Save error:", err);
      showToast("error", "Error", "Failed to save content");
    } finally {
      setSaving(false);
    }
  };

  const saveCompanyInfo = async () => {
    try {
      // Validation checks
      if (!tempCompanyInfo.name || !tempCompanyInfo.name.trim()) {
        showToast("error", "Validation Error", "Company name is required");
        return;
      }

      if (!tempCompanyInfo.email || !tempCompanyInfo.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(tempCompanyInfo.email)) {
        showToast("error", "Validation Error", "A valid email address is required");
        return;
      }

      const cleanPhone = tempCompanyInfo.phone ? tempCompanyInfo.phone.trim().replace(/[\s-()]/g, "") : "";
      if (!cleanPhone || !/^\d{10}$/.test(cleanPhone)) {
        showToast("error", "Validation Error", "A valid 10-digit phone number is required");
        return;
      }

      const formattedGst = tempCompanyInfo.gstNumber ? tempCompanyInfo.gstNumber.trim().toUpperCase() : "";
      if (formattedGst) {
        const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
        if (!gstRegex.test(formattedGst)) {
          showToast("error", "Validation Error", "Please enter a valid 15-character Indian GSTIN (e.g., 27AAAAA0000A1Z1)");
          return;
        }
      }

      setSaving(true);

      if (!companyInfo?._id) {
        showToast("error", "Error", "Company ID not found");
        setSaving(false);
        return;
      }

      // Prepare data for update
      const updateData = {
        name: tempCompanyInfo.name.trim(),
        email: tempCompanyInfo.email.trim(),
        phone: tempCompanyInfo.phone.trim(),
        address: {
          street: tempCompanyInfo.street ? tempCompanyInfo.street.trim() : "",
          city: tempCompanyInfo.city ? tempCompanyInfo.city.trim() : "",
          state: tempCompanyInfo.state ? tempCompanyInfo.state.trim() : "",
          zipCode: tempCompanyInfo.zipCode ? tempCompanyInfo.zipCode.trim() : "",
        },
        gstNumber: formattedGst,
        invoiceNumberPrefix: tempCompanyInfo.invoiceNumberPrefix ? tempCompanyInfo.invoiceNumberPrefix.trim() : "",
      };

      // Remove undefined/null values
      Object.keys(updateData).forEach(key => {
        if (updateData[key] === undefined || updateData[key] === null) {
          delete updateData[key];
        }
      });

      let res;
      if (companyInfo.isFromUserData) {
        console.log("Creating new company with data:", updateData);
        res = await axios.post(
          `${url}/api/company/add`,
          updateData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      } else {
        console.log("Updating company with ID:", companyInfo._id);
        res = await axios.put(
          `${url}/api/company/update/${companyInfo._id}`,
          updateData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }

      console.log("Company save response:", res.data);

      if (res.data?.data) {
        // Update local state with new company info
        setCompanyInfo(prev => ({
          ...prev,
          _id: res.data.data._id,
          name: res.data.data.name,
          email: res.data.data.email,
          phone: res.data.data.phone,
          street: res.data.data.address?.street || "",
          city: res.data.data.address?.city || "",
          state: res.data.data.address?.state || "",
          zipCode: res.data.data.address?.zipCode || "",
          gstNumber: res.data.data.gstNumber || "",
          invoiceNumberPrefix: res.data.data.invoiceNumberPrefix || "",
          isFromUserData: false
        }));
        setCompanyModalOpen(false);
        showToast("success", "Success", "Company information saved successfully");

        // Refetch data to ensure consistency
        fetchData();
      }

    } catch (err) {
      console.error("Company update error:", err);
      const errorMessage = err.response?.data?.message || "Failed to update company information";
      showToast("error", "Error", errorMessage);
    } finally {
      setSaving(false);
    }
  };

  const saveMainPortalStats = async () => {
    try {
      setSaving(true);
      const res = await axios.put(`${url}/api/dummy-stats/main-portal`, tempMainPortalStats, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data?.success) {
        setMainPortalStats(res.data.data);
        setMainPortalStatsModalOpen(false);
        showToast("success", "Success", "Main Portal dummy stats updated successfully");
      }
    } catch (err) {
      console.error("Main Portal stats update error:", err);
      showToast("error", "Error", "Failed to update main portal stats");
    } finally {
      setSaving(false);
    }
  };

  const saveSignature = async () => {
    try {
      setSaving(true);

      if (!signatureCanvasRef.current) {
        showToast("error", "Error", "Signature canvas not available");
        return;
      }

      const isEmpty = signatureCanvasRef.current.isEmpty();
      if (isEmpty) {
        showToast("warning", "Warning", "Please draw a signature first");
        return;
      }

      const dataUrl = signatureCanvasRef.current.toDataURL("image/png");

      const response = await fetch(dataUrl);
      const blob = await response.blob();

      const formData = new FormData();
      formData.append("signature", blob, "signature.png");

      const endpoint = `${url}/api/users/signature/${userData._id}`;
      const method = signature?.hasSignature ? "put" : "post";

      console.log("Saving signature to:", endpoint, "Method:", method);

      const res = await axios[method](endpoint, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      });

      console.log("Signature save response:", res.data);

      if (res.data?.data) {
        const signatureData = res.data.data;
        const fullSignaturePath = getFullImageUrl(signatureData.signaturePath || signatureData.signature);

        setSignatureError(false);
        setSignature({
          ...signatureData,
          signature: fullSignaturePath,
          hasSignature: true
        });
        setSignatureModalOpen(false);
        showToast("success", "Success", "Signature saved successfully");
      }

    } catch (err) {
      console.error("Signature save error:", err);
      showToast("error", "Error", "Failed to save signature");
    } finally {
      setSaving(false);
    }
  };

  const clearSignature = () => {
    if (signatureCanvasRef.current) {
      signatureCanvasRef.current.clear();
    }
  };

  const toggleFullscreen = () => {
    setEditorFullscreen(!editorFullscreen);
  };

  const togglePreviewMode = () => {
    const modes = ["live", "edit", "preview"];
    const currentIndex = modes.indexOf(editorPreviewMode);
    const nextIndex = (currentIndex + 1) % modes.length;
    setEditorPreviewMode(modes[nextIndex]);
  };

  // Updated access control - allow both admins and engineers
  if (!isAdmin && !canHaveSignature) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">Access Denied. Admin or Engineer privileges required.</Typography>
      </Box>
    );
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      {/* Toast Notification */}
      {toast.open && (
        <AppToast
          open={toast.open}
          type={toast.type}
          title={toast.title}
          message={toast.message}
          onClose={() => setToast(prev => ({ ...prev, open: false }))}
        />
      )}

      {/* Error/Success Messages */}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {success}
        </Alert>
      )}

      {/* Company Information Card - Only for admins */}
      {isAdmin && companyInfo && (
        <Card sx={{
          p: { xs: 2, sm: 3 },
          mb: 3,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "stretch", sm: "center" },
          gap: { xs: 2, sm: 0 }
        }}>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.PRIMARY, mb: 2 }}>
              Company Information
            </Typography>
            <Box sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              flexWrap: "wrap",
              gap: { xs: 2, sm: 4 }
            }}>
              <Box sx={{ minWidth: { xs: "100%", sm: "200px" } }}>
                <Typography variant="body2" color="text.secondary">Company Name</Typography>
                <Typography variant="body1">{companyInfo.name || "N/A"}</Typography>
              </Box>
              <Box sx={{ minWidth: { xs: "100%", sm: "200px" } }}>
                <Typography variant="body2" color="text.secondary">Email</Typography>
                <Typography variant="body1">{companyInfo.email || "N/A"}</Typography>
              </Box>
              <Box sx={{ minWidth: { xs: "100%", sm: "200px" } }}>
                <Typography variant="body2" color="text.secondary">Phone</Typography>
                <Typography variant="body1">{companyInfo.phone || "N/A"}</Typography>
              </Box>
              <Box sx={{ minWidth: { xs: "100%", sm: "200px" } }}>
                <Typography variant="body2" color="text.secondary">Address</Typography>
                <Typography variant="body1">
                  {companyInfo.street ? `${companyInfo.street}, ${companyInfo.city}, ${companyInfo.state} - ${companyInfo.zipCode}` : "N/A"}
                </Typography>
              </Box>
              <Box sx={{ minWidth: { xs: "100%", sm: "200px" } }}>
                <Typography variant="body2" color="text.secondary">GSTIN Number</Typography>
                <Typography variant="body1">{companyInfo.gstNumber || "N/A"}</Typography>
              </Box>
              <Box sx={{ minWidth: { xs: "100%", sm: "200px" } }}>
                <Typography variant="body2" color="text.secondary">Invoice Prefix</Typography>
                <Typography variant="body1">{companyInfo.invoiceNumberPrefix || "N/A"}</Typography>
              </Box>

            </Box>
          </Box>
          <Button
            variant="contained"
            onClick={openCompanyModal}
            sx={{
              mt: { xs: 1, sm: 0 },
              ml: { xs: 0, sm: 2 },
              bgcolor: COLORS.SECONDARY,
              whiteSpace: 'nowrap',
              alignSelf: { xs: "flex-start", sm: "center" }
            }}
          >
            Update Company
          </Button>
        </Card>
      )}

      {/* Main Portal Dummy Stats Card - Only for admins */}
      {isAdmin && (
        <Card sx={{
          p: { xs: 2, sm: 3 },
          mb: 3,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "stretch", sm: "center" },
          gap: { xs: 2, sm: 0 }
        }}>
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.PRIMARY, mb: 2 }}>
              Main Portal Dummy Stats
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Manage dummy additions for the main portal dashboard stats.
            </Typography>
            <Box sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              flexWrap: "wrap",
              gap: { xs: 2, sm: 4 }
            }}>
              <Box sx={{ minWidth: { xs: "100%", sm: "150px" } }}>
                <Typography variant="body2" color="text.secondary">Total Clients</Typography>
                <Typography variant="body1">{mainPortalStats?.totalClients || 0}</Typography>
              </Box>
              <Box sx={{ minWidth: { xs: "100%", sm: "150px" } }}>
                <Typography variant="body2" color="text.secondary">Total Engineers</Typography>
                <Typography variant="body1">{mainPortalStats?.totalEngineers || 0}</Typography>
              </Box>
              <Box sx={{ minWidth: { xs: "100%", sm: "150px" } }}>
                <Typography variant="body2" color="text.secondary">Pending Projects</Typography>
                <Typography variant="body1">{mainPortalStats?.pendingProjects || 0}</Typography>
              </Box>
              <Box sx={{ minWidth: { xs: "100%", sm: "150px" } }}>
                <Typography variant="body2" color="text.secondary">Completed Projects</Typography>
                <Typography variant="body1">{mainPortalStats?.completedProjects || 0}</Typography>
              </Box>
              <Box sx={{ minWidth: { xs: "100%", sm: "150px" } }}>
                <Typography variant="body2" color="text.secondary">Total Requests</Typography>
                <Typography variant="body1">{mainPortalStats?.totalRequested || 0}</Typography>
              </Box>
            </Box>
          </Box>
          <Button
            variant="contained"
            onClick={openMainPortalStatsModal}
            sx={{
              mt: { xs: 1, sm: 0 },
              ml: { xs: 0, sm: 2 },
              bgcolor: COLORS.SECONDARY,
              whiteSpace: 'nowrap',
              alignSelf: { xs: "flex-start", sm: "center" }
            }}
          >
            Update Stats
          </Button>
        </Card>
      )}

      {/* Checklist Order Card - Only for admins */}
      {isAdmin && (
        <Card sx={{
          p: { xs: 2, sm: 3 },
          mb: 3,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "stretch", sm: "center" },
          gap: { xs: 2, sm: 0 }
        }}>
          <Box sx={{ flex: 1, pr: { xs: 0, sm: 2 } }}>
            <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.PRIMARY, mb: 1 }}>
              Checklist Templates Order
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Change the display order of checklist templates. Drag and drop to reorder, then save.
            </Typography>
            {checklistTemplates.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  Current order: {checklistTemplates.length} templates
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                  First: {checklistTemplates[0]?.title}
                </Typography>
              </Box>
            )}
          </Box>
          <Button
            variant="contained"
            onClick={openChecklistOrderModal}
            sx={{
              mt: { xs: 1, sm: 0 },
              ml: { xs: 0, sm: 2 },
              bgcolor: COLORS.SECONDARY,
              alignSelf: { xs: "flex-start", sm: "center" }
            }}
          >
            Change Order
          </Button>
        </Card>
      )}

      {/* Thank You Card - Only for admins */}
      {isAdmin && (
        <Card sx={{
          p: { xs: 2, sm: 3 },
          mb: 3,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "stretch", sm: "center" },
          gap: { xs: 2, sm: 0 }
        }}>
          <Box sx={{ flex: 1, pr: { xs: 0, sm: 2 } }}>
            <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.PRIMARY, mb: 1 }}>
              {thankYou.title || "Thank You Message"}
            </Typography>
            <Box sx={{
              color: COLORS.TEXT,
              '& h1, & h2, & h3, & h4, & h5, & h6': {
                fontSize: '1rem !important',
                margin: '0.5rem 0'
              },
              '& p': { margin: '0.5rem 0' },
              '& ul, & ol': { paddingLeft: '1.5rem' },
              '& li': { margin: '0.25rem 0' }
            }}>
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {truncate(thankYou.content, isMobile ? 100 : 150)}
              </ReactMarkdown>
            </Box>
          </Box>
          <Button
            variant="contained"
            onClick={() => openModal("THANK_YOU", "edit")}
            sx={{
              mt: { xs: 1, sm: 0 },
              ml: { xs: 0, sm: 2 },
              bgcolor: COLORS.SECONDARY,
              alignSelf: { xs: "flex-start", sm: "center" }
            }}
          >
            Update
          </Button>
        </Card>
      )}

      {/* Terms & Conditions Card - Only for admins */}
      {isAdmin && (
        <Card sx={{
          p: { xs: 2, sm: 3 },
          mb: 3,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "stretch", sm: "center" },
          gap: { xs: 2, sm: 0 }
        }}>
          <Box sx={{ flex: 1, pr: { xs: 0, sm: 2 } }}>
            <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.PRIMARY, mb: 1 }}>
              {terms.title || "Terms & Conditions"}
            </Typography>
            <Box sx={{
              color: COLORS.TEXT,
              '& h1, & h2, & h3, & h4, & h5, & h6': {
                fontSize: '1rem !important',
                margin: '0.5rem 0'
              },
              '& p': { margin: '0.5rem 0' },
              '& ul, & ol': { paddingLeft: '1.5rem' },
              '& li': { margin: '0.25rem 0' }
            }}>
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {truncate(terms.content, isMobile ? 80 : 100)}
              </ReactMarkdown>
            </Box>
          </Box>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1}
            sx={{
              mt: { xs: 1, sm: 0 },
              ml: { xs: 0, sm: 2 },
              alignSelf: { xs: "flex-start", sm: "center" }
            }}
          >
            <Button
              variant="outlined"
              onClick={() => openModal("TERMS_CONDITIONS", "view")}
              sx={{ minWidth: { xs: "100%", sm: "auto" } }}
            >
              View Full
            </Button>
            <Button
              variant="contained"
              onClick={() => openModal("TERMS_CONDITIONS", "edit")}
              sx={{
                bgcolor: COLORS.SECONDARY,
                minWidth: { xs: "100%", sm: "auto" }
              }}
            >
              Update
            </Button>
          </Stack>
        </Card>
      )}

      {/* Client Notification Card - Only for admins */}
      {isAdmin && (
        <Card sx={{
          p: { xs: 2, sm: 3 },
          mb: 3,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "stretch", sm: "center" },
          gap: { xs: 2, sm: 0 }
        }}>
          <Box sx={{ flex: 1, pr: { xs: 0, sm: 2 } }}>
            <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.PRIMARY, mb: 1 }}>
              {clientNotification.title || "Client Notification Banner"}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              This text is shown at the top of every screen viewed by Clients.
            </Typography>
            <Box sx={{
              color: COLORS.TEXT,
              '& h1, & h2, & h3, & h4, & h5, & h6': {
                fontSize: '1rem !important',
                margin: '0.5rem 0'
              },
              '& p': { margin: '0.5rem 0' },
              '& ul, & ol': { paddingLeft: '1.5rem' },
              '& li': { margin: '0.25rem 0' }
            }}>
              <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
                {truncate(clientNotification.content || "Normal credits are used only upto 35 to 40 km range only \nFor outstation visits above 40 km , please select the outstation option.", isMobile ? 80 : 100)}
              </Typography>
            </Box>
          </Box>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1}
            sx={{
              mt: { xs: 1, sm: 0 },
              ml: { xs: 0, sm: 2 },
              alignSelf: { xs: "flex-start", sm: "center" }
            }}
          >
            <Button
              variant="contained"
              onClick={() => openModal("CLIENT_NOTIFICATION", "edit")}
              sx={{
                bgcolor: COLORS.SECONDARY,
                minWidth: { xs: "100%", sm: "auto" }
              }}
            >
              Update
            </Button>
          </Stack>
        </Card>
      )}

      {/* Signature Card - For both ADMINS and ENGINEERS */}
      {canHaveSignature && (
        <Card sx={{
          p: { xs: 2, sm: 3 },
          mb: 3,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "stretch", sm: "center" },
          gap: { xs: 2, sm: 0 }
        }}>
          <Box sx={{ flex: 1, pr: { xs: 0, sm: 2 } }}>
            <Typography sx={{ ...TYPOGRAPHY.H4, color: COLORS.PRIMARY, mb: 1 }}>
              Signature ({userData?.role})
            </Typography>
            {signature?.hasSignature ? (
              <Box sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "flex-start", sm: "center" },
                gap: 3,
                mt: 1
              }}>
                <Box sx={{
                  height: 100,
                  width: 220,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: `1px solid ${COLORS.BORDER}`,
                  borderRadius: "12px",
                  padding: 2,
                  backgroundColor: '#FFFFFF',
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: '0px 4px 12px rgba(0,0,0,0.03)',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    backgroundImage: `radial-gradient(${COLORS.BORDER} 1px, transparent 1px)`,
                    backgroundSize: '16px 16px',
                    opacity: 0.5,
                    pointerEvents: 'none'
                  }
                }}>
                  {signature?.signature && !signatureError ? (
                    <img
                      key={signature.signature}
                      src={`${signature.signature}${signature.signature?.includes('?') ? '&' : '?'}t=${Date.now()}`}
                      alt="Signature"
                      style={{
                        maxHeight: '100%',
                        maxWidth: '100%',
                        objectFit: 'contain',
                        zIndex: 1,
                        filter: 'contrast(1.1) brightness(1.02)'
                      }}
                      onError={() => {
                        console.error("Signature image failed to load:", signature.signature);
                        setSignatureError(true);
                      }}
                    />
                  ) : (
                    <Box sx={{ 
                      zIndex: 1, 
                      display: 'flex', 
                      flexDirection: 'column', 
                      alignItems: 'center', 
                      gap: 1 
                    }}>
                      <Typography sx={{ 
                        color: COLORS.LIGHT_SECONDARY, 
                        fontSize: "11px", 
                        fontWeight: 700, 
                        textTransform: "uppercase", 
                        letterSpacing: "2px",
                        textAlign: 'center'
                      }}>
                        No Signature<br/>Stored
                      </Typography>
                    </Box>
                  )}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                  <Typography sx={{ 
                    fontSize: "14px", 
                    fontWeight: 700, 
                    color: COLORS.PRIMARY,
                    fontFamily: FONT_FAMILY
                  }}>
                    {signature.userName || userData?.name}
                  </Typography>
                  <Typography sx={{ 
                    fontSize: "12px", 
                    color: COLORS.MUTED_TEXT,
                    fontFamily: FONT_FAMILY,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5
                  }}>
                    <Box component="span" sx={{ fontWeight: 600 }}>Last updated:</Box>
                    {(signature.updatedAt || signature.createdAt) ? new Date(signature.updatedAt || signature.createdAt).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                    }) : "N/A"}
                  </Typography>
                  <Box sx={{ 
                    display: 'inline-flex', 
                    px: 1, 
                    py: 0.25, 
                    bgcolor: 'rgba(101, 45, 144, 0.08)', 
                    borderRadius: '4px',
                    mt: 0.5
                  }}>
                    <Typography sx={{ 
                      fontSize: "10px", 
                      fontWeight: 700, 
                      color: COLORS.SECONDARY,
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px'
                    }}>
                      {userData?.role} SIGNATURE
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box>
                <Typography variant="body1" color="text.secondary">
                  No signature added yet
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {userData?.role === "ENGINEER"
                    ? "Add your signature to sign site checklists"
                    : "Add your signature for admin purposes"}
                </Typography>
              </Box>
            )}
          </Box>
          <Button
            variant="contained"
            onClick={() => setSignatureModalOpen(true)}
            sx={{
              mt: { xs: 1, sm: 0 },
              ml: { xs: 0, sm: 2 },
              bgcolor: COLORS.SECONDARY,
              alignSelf: { xs: "flex-start", sm: "center" }
            }}
          >
            {signature?.hasSignature ? "Update Signature" : "Add Signature"}
          </Button>
        </Card>
      )}

      {/* Checklist Order Modal - Only for admins */}
      <Modal
        open={checklistOrderModalOpen}
        onClose={() => !isUpdatingOrder && setChecklistOrderModalOpen(false)}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95vw', md: '80vw' },
          height: { xs: '95vh', md: '90vh' },
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: { xs: 2, sm: 3 },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 2
        }}>
          {/* Header */}
          <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
            flexShrink: 0
          }}>
            <Typography sx={{
              ...TYPOGRAPHY.H3,
              fontSize: { xs: '1.25rem', sm: '1.5rem' }
            }}>
              Change Checklist Templates Order
            </Typography>
            <IconButton
              onClick={() => !isUpdatingOrder && setChecklistOrderModalOpen(false)}
              disabled={isUpdatingOrder}
            >
              <Icon name="close" />
            </IconButton>
          </Box>

          {/* Instructions */}
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3, flexShrink: 0 }}>
            Drag and drop checklist templates to reorder them. The order will be saved when you click "Save Order".
            Templates are initially sorted by creation date (oldest first).
          </Typography>

          {/* Checklist Templates List */}
          <Paper
            sx={{
              flex: 1,
              overflow: 'auto',
              mb: 3,
              p: 2,
              bgcolor: '#f9f9f9'
            }}
          >
            <List sx={{ width: '100%' }}>
              {checklistTemplates.map((template, index) => (
                <React.Fragment key={template._id}>
                  <ListItem
                    sx={{
                      mb: 1,
                      bgcolor: 'white',
                      borderRadius: 1,
                      border: '1px solid #e0e0e0',
                      cursor: 'move',
                      userSelect: 'none',
                      transition: 'all 0.2s ease',
                      opacity: draggedItem === index ? 0.5 : 1,
                      backgroundColor: dropTarget === index ? '#e3f2fd' : 'white',
                      boxShadow: draggedItem === index ? 2 : 0,
                      '&:hover': {
                        boxShadow: 2,
                      }
                    }}
                    draggable
                    onDragStart={(e) => handleDragStart(e, index)}
                    onDragOver={(e) => handleDragOver(e, index)}
                    onDragEnd={handleDragEnd}
                    onDrop={(e) => handleDrop(e, index)}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mr: 2,
                        minWidth: 30
                      }}>
                        <Icon name="grip-vertical" color={COLORS.LIGHT_SECONDARY} size={20} />
                      </Box>

                      <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mr: 2,
                        minWidth: 40
                      }}>
                        <Typography
                          sx={{
                            ...TYPOGRAPHY.BODY_LARGE,
                            fontWeight: 'bold',
                            color: COLORS.PRIMARY
                          }}
                        >
                          {index + 1}.
                        </Typography>
                      </Box>

                      <ListItemText
                        primary={
                          <Typography sx={{ ...TYPOGRAPHY.BODY_LARGE, color: COLORS.PRIMARY }}>
                            {template.title}
                          </Typography>
                        }
                        secondary={
                          <Box>
                            <Typography variant="body2" color="text.secondary">
                              Created: {new Date(template.createdAt).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "2-digit",
                              }).replace(/\//g, '/')}
                            </Typography>
                            {template.description && (
                              <Typography variant="body2" color="text.secondary">
                                {truncate(template.description, 100)}
                              </Typography>
                            )}
                          </Box>
                        }
                      />

                      <ListItemSecondaryAction>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Typography variant="body2" color="text.secondary" sx={{ mr: 2 }}>
                            {template.isActive ? 'Active' : 'Inactive'}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Sections: {template.sections?.length || 0}
                          </Typography>
                        </Box>
                      </ListItemSecondaryAction>
                    </Box>
                  </ListItem>
                  {index < checklistTemplates.length - 1 && (
                    <Divider sx={{ mb: 1 }} />
                  )}
                </React.Fragment>
              ))}

              {checklistTemplates.length === 0 && (
                <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  py: 8
                }}>
                  <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                    No checklist templates found
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Create checklist templates first to reorder them
                  </Typography>
                </Box>
              )}
            </List>
          </Paper>

          {/* Footer */}
          <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pt: 2,
            borderTop: 1,
            borderColor: 'divider',
            flexShrink: 0
          }}>
            <Typography variant="body2" color="text.secondary">
              Total: {checklistTemplates.length} templates
            </Typography>

            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                onClick={() => setChecklistOrderModalOpen(false)}
                variant="outlined"
                disabled={isUpdatingOrder}
                sx={{ minWidth: { xs: '80px', sm: '100px' } }}
              >
                Cancel
              </Button>
              <Button
                onClick={saveChecklistOrder}
                variant="contained"
                disabled={isUpdatingOrder || checklistTemplates.length === 0}
                sx={{
                  bgcolor: COLORS.SECONDARY,
                  minWidth: { xs: '80px', sm: '120px' }
                }}
              >
                {isUpdatingOrder ? (
                  <>
                    <CircularProgress size={20} sx={{ mr: 1 }} />
                    Saving...
                  </>
                ) : (
                  'Save Order'
                )}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Content Modal - Only for admins */}
      <Modal
        open={modalOpen}
        onClose={() => !saving && setModalOpen(false)}
        sx={{
          '& .MuiBackdrop-root': {
            backgroundColor: editorFullscreen ? 'rgba(0, 0, 0, 0.9)' : 'rgba(0, 0, 0, 0.5)'
          }
        }}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: editorFullscreen ? '100vw' : { xs: '95vw', md: '90vw' },
          height: editorFullscreen ? '100vh' : { xs: '95vh', md: '90vh' },
          bgcolor: 'background.paper',
          boxShadow: editorFullscreen ? 'none' : 24,
          p: editorFullscreen ? 0 : { xs: 2, sm: 4 },
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: editorFullscreen ? 0 : 2
        }}>
          {/* Header with controls */}
          <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
            p: editorFullscreen ? 2 : 0,
            borderBottom: editorFullscreen ? '1px solid #ddd' : 'none',
            backgroundColor: editorFullscreen ? '#f5f5f5' : 'transparent'
          }}>
            <Typography sx={{
              ...TYPOGRAPHY.H3,
              fontSize: { xs: '1.25rem', sm: '1.5rem' },
              color: editorFullscreen ? '#000' : 'inherit'
            }}>
              {modalMode === "view" ? "View" : "Edit"} -
              {activeType === "THANK_YOU" && " Thank You"}
              {activeType === "TERMS_CONDITIONS" && " Terms & Conditions"}
              {activeType === "CLIENT_NOTIFICATION" && " Client Notification Banner"}
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {modalMode === "edit" && (
                <>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={togglePreviewMode}
                    sx={{
                      minWidth: 'auto',
                      px: 1,
                      fontSize: '0.75rem'
                    }}
                  >
                    {editorPreviewMode === "live" && "Split View"}
                    {editorPreviewMode === "edit" && "Edit Only"}
                    {editorPreviewMode === "preview" && "Preview Only"}
                  </Button>

                  <Button
                    variant="outlined"
                    size="small"
                    onClick={toggleFullscreen}
                    sx={{
                      minWidth: 'auto',
                      px: 1,
                      fontSize: '0.75rem'
                    }}
                  >
                    {editorFullscreen ? "Exit Fullscreen" : "Fullscreen"}
                  </Button>
                </>
              )}

              <IconButton
                onClick={() => !saving && setModalOpen(false)}
                disabled={saving}
                sx={{
                  color: editorFullscreen ? '#000' : 'inherit'
                }}
              >
                <Icon name="close" />
              </IconButton>
            </Box>
          </Box>

          {modalMode === "edit" && (
            <TextField
              fullWidth
              label="Title"
              value={tempData.title}
              onChange={e => setTempData({ ...tempData, title: e.target.value })}
              sx={{
                mb: 3,
                px: editorFullscreen ? 2 : 0
              }}
              disabled={saving}
            />
          )}

          {/* Content Area - SIMPLIFIED EDITOR */}
          {modalMode === "edit" ? (
            <Box sx={{
              flex: 1,
              overflow: 'hidden',
              mb: 2,
              px: editorFullscreen ? 2 : 0,
              '& .w-md-editor': {
                height: '100% !important',
                border: '1px solid #ddd',
                borderRadius: 1
              },
              '& .w-md-editor-content': {
                height: 'calc(100% - 40px) !important'
              }
            }}>
              <MDEditor
                value={tempData.content}
                onChange={(value) => setTempData({ ...tempData, content: value || "" })}
                height="100%"
                preview={editorPreviewMode}
                visibleDragbar={editorPreviewMode === "live"}
                textareaProps={{
                  placeholder: `Enter ${activeType === "THANK_YOU" ? "Thank You"
                    : activeType === "CLIENT_NOTIFICATION" ? "Notification"
                      : "Terms & Conditions"
                    } content here...`,
                }}
              />
            </Box>
          ) : (
            <Box sx={{
              flex: 1,
              overflow: 'auto',
              p: 2,
              bgcolor: '#f5f5f5',
              borderRadius: 1,
              mb: 2,
              mx: editorFullscreen ? 2 : 0
            }}>
              <Box sx={{
                '& h1': { fontSize: '1.8rem', margin: '1rem 0', fontWeight: 'bold' },
                '& h2': { fontSize: '1.5rem', margin: '0.8rem 0', fontWeight: 'bold' },
                '& h3': { fontSize: '1.3rem', margin: '0.6rem 0', fontWeight: 'bold' },
                '& h4': { fontSize: '1.1rem', margin: '0.5rem 0', fontWeight: 'bold' },
                '& p': { margin: '0.5rem 0', lineHeight: '1.6' },
                '& ul, & ol': { paddingLeft: '2rem', margin: '0.5rem 0' },
                '& li': { margin: '0.3rem 0', lineHeight: '1.5' },
                '& blockquote': {
                  borderLeft: '4px solid #ddd',
                  paddingLeft: '1rem',
                  margin: '1rem 0',
                  color: '#666',
                  fontStyle: 'italic'
                },
                '& code': {
                  backgroundColor: '#f0f0f0',
                  padding: '0.2rem 0.4rem',
                  borderRadius: '3px',
                  fontFamily: 'monospace'
                },
                '& pre': {
                  backgroundColor: '#f5f5f5',
                  padding: '1rem',
                  borderRadius: '4px',
                  overflow: 'auto'
                },
                '& table': {
                  borderCollapse: 'collapse',
                  width: '100%',
                  margin: '1rem 0'
                },
                '& th, & td': {
                  border: '1px solid #ddd',
                  padding: '0.5rem',
                  textAlign: 'left'
                },
                '& th': {
                  backgroundColor: '#f0f0f0',
                  fontWeight: 'bold'
                }
              }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {tempData.content}
                </ReactMarkdown>
              </Box>
            </Box>
          )}

          {modalMode === "edit" && (
            <Box sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 2,
              pt: 2,
              borderTop: 1,
              borderColor: 'divider',
              px: editorFullscreen ? 2 : 0
            }}>
              <Button
                onClick={() => setModalOpen(false)}
                variant="outlined"
                disabled={saving}
                sx={{ minWidth: { xs: '80px', sm: '100px' } }}
              >
                Cancel
              </Button>
              <Button
                onClick={save}
                variant="contained"
                disabled={saving}
                sx={{
                  bgcolor: COLORS.SECONDARY,
                  minWidth: { xs: '80px', sm: '100px' }
                }}
              >
                {saving ? <CircularProgress size={24} /> : "Save"}
              </Button>
            </Box>
          )}
        </Box>
      </Modal>

      {/* Company Info Dialog - Only for admins */}
      {isAdmin && (
        <Dialog 
          open={companyModalOpen} 
          onClose={() => !saving && setCompanyModalOpen(false)}
          fullWidth
          maxWidth="sm"
          PaperProps={{
            sx: {
              borderRadius: 2,
            }
          }}
        >
          <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 2, pt: 3, px: { xs: 2, sm: 3 } }}>
            <Typography sx={{ ...TYPOGRAPHY.H3, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
              Update Company Information
            </Typography>
            <IconButton onClick={() => !saving && setCompanyModalOpen(false)} disabled={saving}>
              <Icon name="close" />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers sx={{ p: { xs: 2, sm: 3 } }}>
            <Stack spacing={3} sx={{ mt: 1, mb: 1 }}>
              <TextField
                fullWidth
                label="Company Name"
                value={tempCompanyInfo.name}
                onChange={e => setTempCompanyInfo({ ...tempCompanyInfo, name: e.target.value })}
                disabled={saving}
                required
              />
              <TextField
                fullWidth
                label="Email"
                type="email"
                value={tempCompanyInfo.email}
                onChange={e => setTempCompanyInfo({ ...tempCompanyInfo, email: e.target.value })}
                disabled={saving}
                required
              />
              <TextField
                fullWidth
                label="Phone"
                value={tempCompanyInfo.phone}
                onChange={e => setTempCompanyInfo({ ...tempCompanyInfo, phone: e.target.value })}
                disabled={saving}
                required
              />
              <TextField
                fullWidth
                label="Street Address"
                value={tempCompanyInfo.street}
                onChange={e => setTempCompanyInfo({ ...tempCompanyInfo, street: e.target.value })}
                disabled={saving}
              />
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="City"
                    value={tempCompanyInfo.city}
                    onChange={e => setTempCompanyInfo({ ...tempCompanyInfo, city: e.target.value })}
                    disabled={saving}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="State"
                    value={tempCompanyInfo.state}
                    onChange={e => setTempCompanyInfo({ ...tempCompanyInfo, state: e.target.value })}
                    disabled={saving}
                  />
                </Grid>
              </Grid>
              <TextField
                fullWidth
                label="Zip Code"
                value={tempCompanyInfo.zipCode}
                onChange={e => setTempCompanyInfo({ ...tempCompanyInfo, zipCode: e.target.value })}
                disabled={saving}
              />
              <TextField
                fullWidth
                label="GSTIN Number"
                value={tempCompanyInfo.gstNumber}
                onChange={e => setTempCompanyInfo({ ...tempCompanyInfo, gstNumber: e.target.value })}
                disabled={saving}
              />
              <TextField
                fullWidth
                label="Invoice Number Prefix"
                value={tempCompanyInfo.invoiceNumberPrefix}
                onChange={e => setTempCompanyInfo({ ...tempCompanyInfo, invoiceNumberPrefix: e.target.value })}
                disabled={saving}
                helperText="Use placeholders: YYYY (Year), MM (Month), DD (Day). E.g., INV/YYYYMMDD/"
              />
            </Stack>
          </DialogContent>

          <DialogActions sx={{ p: { xs: 2, sm: 3 }, gap: 2 }}>
            <Button
              onClick={() => setCompanyModalOpen(false)}
              variant="outlined"
              disabled={saving}
              sx={{ minWidth: { xs: '80px', sm: '100px' } }}
            >
              Cancel
            </Button>
            <Button
              onClick={saveCompanyInfo}
              variant="contained"
              disabled={saving}
              sx={{
                bgcolor: COLORS.PRIMARY,
                color: "white",
                '&:hover': {
                  bgcolor: COLORS.PRIMARY,
                  opacity: 0.9
                },
                minWidth: { xs: '80px', sm: '100px' }
              }}
            >
              {saving ? <CircularProgress size={24} color="inherit" /> : "Save"}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Main Portal Dummy Stats Modal - Only for admins */}
      {isAdmin && (
        <Modal open={mainPortalStatsModalOpen} onClose={() => !saving && setMainPortalStatsModalOpen(false)}>
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90vw', sm: 500 },
            maxWidth: '95vw',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: { xs: 2, sm: 4 },
            borderRadius: 2,
            maxHeight: '90vh',
            overflowY: 'auto'
          }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
              <Typography sx={{ ...TYPOGRAPHY.H3, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
                Update Main Portal Dummy Stats
              </Typography>
              <IconButton onClick={() => !saving && setMainPortalStatsModalOpen(false)} disabled={saving}>
                <Icon name="close" />
              </IconButton>
            </Box>

            <Stack spacing={3}>
              <TextField
                fullWidth
                label="Total Clients"
                type="number"
                value={tempMainPortalStats.totalClients}
                onChange={e => setTempMainPortalStats({ ...tempMainPortalStats, totalClients: e.target.value === '' ? '' : Number(e.target.value) })}
                disabled={saving}
              />
              <TextField
                fullWidth
                label="Total Engineers"
                type="number"
                value={tempMainPortalStats.totalEngineers}
                onChange={e => setTempMainPortalStats({ ...tempMainPortalStats, totalEngineers: e.target.value === '' ? '' : Number(e.target.value) })}
                disabled={saving}
              />
              <TextField
                fullWidth
                label="Pending Projects"
                type="number"
                value={tempMainPortalStats.pendingProjects}
                onChange={e => setTempMainPortalStats({ ...tempMainPortalStats, pendingProjects: e.target.value === '' ? '' : Number(e.target.value) })}
                disabled={saving}
              />
              <TextField
                fullWidth
                label="Completed Projects"
                type="number"
                value={tempMainPortalStats.completedProjects}
                onChange={e => setTempMainPortalStats({ ...tempMainPortalStats, completedProjects: e.target.value === '' ? '' : Number(e.target.value) })}
                disabled={saving}
              />
              <TextField
                fullWidth
                label="Total Requests"
                type="number"
                value={tempMainPortalStats.totalRequested}
                onChange={e => setTempMainPortalStats({ ...tempMainPortalStats, totalRequested: e.target.value === '' ? '' : Number(e.target.value) })}
                disabled={saving}
              />
            </Stack>

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 4 }}>
              <Button 
                onClick={() => setMainPortalStatsModalOpen(false)} 
                variant="outlined"
                disabled={saving}
                sx={{ minWidth: { xs: '80px', sm: '100px' } }}
              >
                Cancel
              </Button>
              <Button 
                onClick={saveMainPortalStats} 
                variant="contained" 
                disabled={saving}
                sx={{ 
                  bgcolor: COLORS.SECONDARY,
                  minWidth: { xs: '80px', sm: '100px' }
                }}
              >
                {saving ? <CircularProgress size={24} /> : "Update"}
              </Button>
            </Box>
          </Box>
        </Modal>
      )}

      {/* Signature Modal - For both ADMINS and ENGINEERS */}
      <Modal open={signatureModalOpen} onClose={() => !saving && setSignatureModalOpen(false)}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95vw', sm: 600 },
          maxWidth: '95vw',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: { xs: 2, sm: 4 },
          borderRadius: 2
        }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
            <Typography sx={{ ...TYPOGRAPHY.H3, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}>
              {signature?.hasSignature ? "Update Signature" : "Add Signature"} ({userData?.role})
            </Typography>
            <IconButton onClick={() => !saving && setSignatureModalOpen(false)} disabled={saving}>
              <Icon name="close" />
            </IconButton>
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            {userData?.role === "ENGINEER"
              ? "Draw your signature below. This signature will be used to sign site checklists and reports."
              : "Draw your signature in the area below. Use mouse on desktop or finger/stylus on touch devices."}
          </Typography>

          <SignatureCanvas
            ref={signatureCanvasRef}
            height={200}
          />

          <Box sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            gap: 2,
            mt: 3
          }}>
            <Button
              onClick={clearSignature}
              variant="outlined"
              color="error"
              disabled={saving}
              sx={{
                minWidth: { xs: '100%', sm: 'auto' },
                order: { xs: 2, sm: 1 }
              }}
            >
              Clear
            </Button>
            <Box sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              order: { xs: 1, sm: 2 },
              width: { xs: '100%', sm: 'auto' }
            }}>
              <Button
                onClick={() => setSignatureModalOpen(false)}
                variant="outlined"
                disabled={saving}
                sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
              >
                Cancel
              </Button>
              <Button
                onClick={saveSignature}
                variant="contained"
                disabled={saving}
                sx={{
                  bgcolor: COLORS.SECONDARY,
                  minWidth: { xs: '100%', sm: 'auto' }
                }}
              >
                {saving ? <CircularProgress size={24} /> : "Save Signature"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default GeneralSettings;